/**
 * Japanese translations for documentation pages
 */

const ja: Record<string, string> = {
  // Common
  'common.backToHome': 'ホームに戻る',
  'common.backToDocs': 'ドキュメントに戻る',
  'common.learnMore': '詳細を見る',
  'common.getStarted': '始める',
  'common.viewDocs': 'ドキュメントを見る',
  'common.signIn': 'ログイン',
  'common.signUp': '新規登録',
  'common.dashboard': 'ダッシュボード',
  'common.footer': '2025 Kizuna AI Lab. All rights reserved.',
  'common.language': '言語',

  // Theme
  'theme.label': 'テーマ',
  'theme.light': 'ライト',
  'theme.dark': 'ダーク',
  'theme.system': 'システム',

  // Navigation
  'nav.home': 'ホーム',
  'nav.docs': 'ドキュメント',
  'nav.scenarios': 'シナリオ',
  'nav.features': '機能',
  'nav.signIn': 'ログイン',
  'nav.providers': 'プロバイダ',
  'nav.docsShort': 'ドキュメント',
  'footer.tagline': 'Kizuna AI Lab より。壁を壊し、つながりをつくる。',
  'footer.trust': 'フリー＆オープンソース · オンデバイスAIも込み · サブスクなし',
  'footer.product': 'プロダクト',
  'footer.install': 'インストール',
  'footer.open': 'オープン',
  'footer.byok': '自分の鍵を使う',
  'footer.extension': '拡張機能',
  'footer.gettingStarted': 'はじめかた',
  'footer.meetingSites': '対応する会議サイト',
  'footer.providerSetup': 'プロバイダの設定',
  'footer.subtitleMode': '字幕モード',
  'nav.localAi': 'ローカルAI',
  'nav.download': 'ダウンロード',
  'demo.me': '自分',
  'demo.other': '相手',
  'demo.both': '両者',
  'demo.src': '原文',
  'demo.trans': '訳文',
  'demo.subtitle': '字幕',
  'demo.exitSubtitle': '字幕モードを終了',
  'demo.settings': '設定',
  'demo.channel.mic': 'あなたのマイク',
  'demo.channel.sys': '相手の音声',
  'demo.channel.out': 'Sokuji が話す音声',
  'demo.endSession': 'セッションを終了',
  'home.scenarios.title': '何をしたいですか。',
  'home.scenarios.lead': 'Sokuji は、言語を越える手間を「伝わりたい側」が引き受ける形で作られています。最初に作ったのはそこです。ただ、いつもあなたがその側とはかぎりません。講義を聞いている、録音を再生している、他人が立てた通話に入っている、ということもあります。',
  'home.scenarios.featured': '最初に作ったのはこれ',
  'home.scenarios.more': '各プリセットの設定内容',
  'home.install.title': 'アプリを入れる。あるいはブラウザに追加する。',
  'home.install.lead': 'デスクトップアプリは対応サイトの一覧に縛られません。OS に普通のマイクとして登録されるので、マイクを選べるものならどれでも使えます。',
  'home.install.desktop.title': 'デスクトップアプリ — システムレベル',
  'home.install.desktop.body': 'Sokuji は OS 上の普通のマイクとして現れます。会議アプリ、ブラウザ、録音ソフト、配信ソフト、ゲーム——マイクを選べるなら、あなたの訳された声が届きます。',
  'home.install.desktop.note': '逆方向は誰の許可も要りません。Sokuji は本体が再生している音をそのまま読むので、システム音も含めて、動画も配信も録音も通話と同じように字幕になります。',
  'home.install.routing.linux': 'PulseAudio / PipeWire に標準対応',
  'home.install.routing.macos': 'ドライバはアプリに同梱',
  'home.install.routing.windows': 'VB-CABLE 経由',
  'home.install.ext.title': 'ブラウザ拡張機能',
  'home.install.ext.body': 'システムには何も入れず、音声のルーティング設定も不要。対応する会議サイト向けに作られています。',
  'home.install.ext.note': 'そのページの中では、訳されたあなたの声がサイトにマイクとして渡され、タブ自身の音声が訳して返ってきます。それ以外——別のアプリ、ブラウザ外の動画、システム音——はデスクトップアプリの担当です。',
  'flow.youSpeak': 'あなたが話す',
  'flow.translates': 'sokuji が訳す',
  'flow.virtualMic': '仮想マイク',
  'flow.anyApp': '任意のアプリ',
  'flow.theyHear': '相手が聞く',
  'flow.them': '相手',
  'flow.yourScreen': 'あなたの画面',
  'flow.audience': '聴衆',
  'flow.onScreen': '画面に',
  'providers.page.title': '翻訳が実際に行われる場所',
  'providers.page.lead': 'Sokuji 自身が認識や翻訳をするわけではありません。あなたの声を取り込み、どこかへ送り、返ってきた答えを通話に話します。その「どこか」を選ぶのはあなたです。道は三つあり、どれかに縛られることはありません。',
  'providers.routes.title': '三つの道',
  'providers.local.chip': '無料 · アカウント不要 · オフライン',
  'providers.own.chip': '鍵はあなたが持つ · 請求もあなたに',
  'providers.managed.chip': '従量課金 · サブスクなし',
  'providers.table.title': '対応プロバイダ',
  'providers.table.lead': 'Sokuji はこれらのアダプタを同梱しています。「発話」は、テキストだけでなく話された翻訳を出せるという意味で、看板のシナリオが必要とするのはそれです。Kizuna AI アカウントが使える行では、実際にモデルを動かすベンダー名を書いています。あなたの音声を受け取るのはそこだからです。「対面」は 1 本のマイクを 2 人で使い、それぞれが片耳のイヤホンで相手の訳を聞く使い方です。これができるプロバイダは、相手側の複数の話し手も聞き分けます。',
  'providers.col.provider': 'プロバイダ',
  'providers.col.runs': '動かし方',
  'providers.col.speaks': '発話',
  'providers.col.faceToFace': '対面',
  'providers.col.setup': '設定',
  'providers.speaks.yes': 'はい',
  'providers.speaks.textOnly': 'テキストのみ',
  'providers.speaks.depends': '場合による',
  'providers.faceToFace.yes': '対応',
  'providers.faceToFace.no': '非対応',
  'providers.guide': '手順',
  'providers.run.local': '自分のマシン上。GPU に合わせてエンジンをダウンロード',
  'providers.run.direct': 'あなたの鍵で {vendor} に直接',
  'providers.run.keyOrAccount': 'あなたの鍵、または Kizuna AI アカウント — ベンダー: {vendor}',
  'providers.run.webrtc': 'あなたの鍵、WebRTC 経由',
  'providers.cost.title': 'アカウントにかかる費用',
  'providers.cost.lead': '費用がかかるのはこの道だけです。Sokuji 自体はフリーでオープンソース、端末上の推論もそのまま無料です。',
  'providers.cost.metered.title': '従量制、月額ではなく',
  'providers.cost.metered.body': '残高をチャージし、使った分だけ引かれます。使わなかった月はゼロ円で、席数もありません。',
  'providers.cost.metered.body2': 'ここに単一の価格を書けないのは、ベンダーごとに数え方が違うからです。音声の長さで数えるところもあれば、モデルが処理した量で数えるところもあります。適用されるレートは、支払う前にアカウント内でそのベンダーの横に表示されているものです。',
  'providers.cost.path.title': 'それでも経路上にはいない',
  'providers.cost.path.body': '私たちに支払っても、私たちがあなたとモデルのあいだに入るわけではありません。端末に資格情報を渡し、その使用量を数えるだけです。音声は自分の鍵を使うときとまったく同じく、端末からベンダーへ直接流れます。',
  'providers.cost.wired': 'どう配線されているかを見る',
  'providers.cost.note': '残高の有効期限は1年です。この期限があるのは、使われていないクレジットが会計上の負債として残るからで、使わせるためではありません。',
  'providers.own.title': '自分の API キー',
  'providers.own.body': '下のどのプロバイダでも登録し、鍵を Sokuji に貼り付けて、そのプロバイダに直接支払います。それぞれにスクリーンショット付きの手順を書きました。私たちを経由するものは一切ありません。',
  'providers.managed.title': 'Kizuna AI アカウント経由で',
  'providers.managed.body': '開発者コンソールを触りたくない人のために。鍵は私たちが持ち、支払いも私たちがまとめます。モデルを動かすのは変わらず Soniox か Qwen です。音声はそのまま彼らへ届き、私たちは経路上にいません。',
  'providers.local.title': '自分のマシンの上で',
  'providers.local.body': 'GPU に合った推論エンジンをダウンロードし、認識と翻訳をローカルで走らせます。無料、ネットワークを切っても動き、端末から何も出ていきません。私たちのところにも。',
  'providers.price.title': 'ここに料金を載せない理由',
  'providers.price.body': '課金方式はベンダーごとに違います——分単位、文字単位、トークン単位、リクエスト単位——そして同じ1分の発話でも内容によって金額が変わります。このページに単一の数字を載せれば、読んだほとんどの人にとって間違いになります。あなたに適用される料金は、該当ベンダーごとにアカウント画面に表示されます。',
  'localai.page.title': 'オンデバイスは代替ではない',
  'localai.page.lead': 'Sokuji は端末上での認識・翻訳・音声合成を無料で同梱しています。ネットワークが落ちたときのためのものではありません。一級の選択肢であり、いずれ既定になると考えています。',
  'localai.honest.lead': '大げさに売るより、はっきり言っておきます。',
  'localai.tomorrow.strong': 'AI を使うためだけに、自分の会話を大手AI企業に渡さなければならない、ということがあってはなりません。',
  'localai.data.title': 'それぞれの道が、あなたのデータに何を意味するか',
  'localai.data.lead': '三つのうち、答えに但し書きが要らないのはこれだけです。',
  'localai.col.ownKey': '自分の鍵',
  'localai.col.account': 'Kizuna AI アカウント',
  'localai.col.onDevice': 'オンデバイス',
  'localai.row.leaves': '音声がマシンの外に出る',
  'localai.row.hear': 'ほかの誰かが聞ける',
  'localai.row.offline': 'ネットワークを切っても動く',
  'localai.row.costs': '費用',
  'localai.val.toVendor': 'ベンダーへ',
  'localai.val.never': '出ない',
  'localai.val.vendorCan': 'ベンダーは聞ける',
  'localai.val.nobody': '誰も聞けない',
  'localai.val.no': 'いいえ',
  'localai.val.yes': 'はい',
  'localai.val.vendorBills': 'ベンダーが請求する',
  'localai.val.meteredByUs': '私たちが計量する',
  'localai.val.free': '無料',
  'localai.what.title': 'マシンの上で動くもの',
  'localai.chain.title': '認識・翻訳・音声',
  'localai.chain.body': '鎖のすべてがローカルで動きます。ASR が声を文字にし、MT が訳し、TTS が話す。どの段もネットワークを必要としません。',
  'localai.engine.title': 'ハードウェアに合わせたエンジン',
  'localai.engine.body': 'Sokuji が GPU を検出し、それ向けに作られたエンジンをダウンロードします。どれを選び、どれくらいの大きさかも表示します。',
  'localai.nokey.title': '鍵なし、アカウントなし、メーターなし',
  'localai.nokey.body': '登録するものも、払うものもありません。費用はあなたのハードウェアだけです。',
  'localai.honest.title': 'クラウドのほうがまだ良いのに、それでも同梱する理由',
  'localai.today.title': 'いまの立ち位置',
  'localai.today.body': '大きなホスト型モデルのほうが、精度でも遅延でもまだ先を行っています。重要な通話ならそちらを選ぶでしょう。端末上の出力も多くの会話には十分で、しかもあなた以外の誰も関わらない唯一の構成です。',
  'localai.tomorrow.title': 'これからどうなると見ているか',
  'localai.tomorrow.body': 'モデルは小さくなり続け、ランタイムは良くなり続け、普通のノートPCのアクセラレータも速くなり続けています。この差が続くとは思っていませんし、埋まるのを待ってからローカルを第一候補にするつもりもありません。',
  'privacyPage.hero.kicker': 'プライバシー',
  'privacyPage.hero.title': '会議の内容は、あなたとあなたが選んだ AI のあいだだけを行き来します。',
  'privacyPage.hero.lead': 'Sokuji をどう使っても、音声、画面の画像、文字起こし、翻訳は、あなたのデバイスから選んだ AI プロバイダへ直接送られ、Kizuna AI を経由することはありません。違うのは、そのプロバイダと誰が精算するかだけです。',
  'privacyPage.hero.exception': '唯一の例外：Kizuna AI アカウントで音声を複製するとき、あなたが録音した音声サンプルは、私たちのサーバーを通って Soniox に渡されます。私たちは音声を一切保存しません。サンプルは渡し終えた時点で破棄し、サーバーに残すのは Soniox が返す音声 ID だけです。',
  'privacyPage.hero.flowLabel': '会議の内容は、あなたのデバイスから選んだ AI プロバイダへ直接送られます。Kizuna AI アカウントを使う場合は、それとは別に Kizuna AI への線が一本あり、そこを通るのはアカウント、残高、使用量だけです。',
  'privacyPage.node.device': 'あなたのデバイス',
  'privacyPage.node.provider': 'AI プロバイダ',
  'privacyPage.node.kizuna': 'Kizuna AI',
  'privacyPage.node.stays': '内容はこのマシンから出ません',
  'privacyPage.way.ownKey.title': '自分の鍵で',
  'privacyPage.way.ownKey.body': 'AI プロバイダに直接支払います。あなたのセッションが私たちのサーバーを通ることはありません。',
  'privacyPage.way.ownKey.note': 'Kizuna AI：関与なし',
  'privacyPage.way.kizuna.title': 'Kizuna AI アカウントで',
  'privacyPage.way.kizuna.body': '私たちが短時間だけ有効な鍵を発行し、使用量に応じて請求します。それでも内容は AI プロバイダへ直接送られます。',
  'privacyPage.way.kizuna.note': '破線を通るのは、アカウント、残高、使用量だけです',
  'privacyPage.way.local.title': '自分のマシンで',
  'privacyPage.way.local.body': 'オンデバイスモデルを使うときは、モデルがあなたのパソコンの上で動き、会議の内容がパソコンの外に出ることはありません。',
  'privacyPage.way.local.note': 'モデルをダウンロードすれば、オフラインで使えます。それまでは、Microsoft のオンラインエンジンが自動で使われることがあります（下記参照）',
  'privacyPage.dest.title': 'データの種類ごとの行き先',
  'privacyPage.dest.lead': 'これが完全な一覧です。ここに載っていない会議の内容が、あなたのデバイスから出ることはありません。',
  'privacyPage.dest.contacts': 'このほか Sokuji は、会議の内容を含まない通信をいくつか行います。オンデバイスモデルのダウンロード、更新の確認、利用統計とエラーレポートの送信です。なお、ローカル推論のうち「オンライン」と表示されたエンジン（Edge TTS の読み上げ、Bing 翻訳）は、あなたのパソコンの上では動きません。使えるオンデバイスモデルがないときは自動で使われ、あなたが選んだときにも使われます。そのとき、読み上げや翻訳の対象となるテキストが Microsoft に送られます。',
  'privacyPage.dest.provider.title': 'あなたが選んだ AI プロバイダ',
  'privacyPage.dest.provider.who': '認識、翻訳、読み上げを担当',
  'privacyPage.dest.provider.voices': 'あなたの声と相手の声',
  'privacyPage.dest.provider.screen': '画面の画像（画面コンテキストがオンのとき）',
  'privacyPage.dest.provider.text': '文字起こしと翻訳',
  'privacyPage.dest.provider.voiceSample': '音声の複製に使う音声サンプル',
  'privacyPage.dest.provider.foot': '各プロバイダ自身のプライバシー条項に従って扱われます。',
  'privacyPage.dest.provider.link': 'プロバイダ一覧を見る',
  'privacyPage.dest.kizuna.title': 'Kizuna AI',
  'privacyPage.dest.kizuna.who': 'Kizuna AI アカウントを使うときだけ',
  'privacyPage.dest.kizuna.email': 'メールアドレスと、登録時に入力した名前（ニックネームでも構いません）',
  'privacyPage.dest.kizuna.logins': 'ログイン記録（IP アドレス、端末、おおよその位置）',
  'privacyPage.dest.kizuna.billing': '残高、チャージ、セッションごとの使用量。あわせて、支払いの確認に使う Stripe からの支払い情報',
  'privacyPage.dest.kizuna.feedback': 'あなたが自分から送ったフィードバック',
  'privacyPage.dest.kizuna.foot': '画像、文字起こし、翻訳は含みません。音声も含みませんが、Soniox に渡す音声の複製用サンプルだけは例外です（上記参照）。',
  'privacyPage.dest.device.title': 'あなたの手元に残るもの',
  'privacyPage.dest.device.who': 'どのモードでも',
  'privacyPage.dest.device.history': 'セッション履歴とエクスポートしたファイル',
  'privacyPage.dest.device.settings': 'あなたの設定と自分の鍵：デスクトップアプリではパソコンに保存されます。モバイルアプリではスマートフォンに保存されます。ブラウザ拡張機能では、Chrome 同期がオンのとき、あなたの Google アカウントを通じて同期されます',
  'privacyPage.dest.device.local': 'オンデバイスモデルだけを使うときの会議の内容すべて',
  'privacyPage.dest.device.foot': 'アプリ内で削除するか、ブラウザのデータを消去するか、アプリのデータフォルダを削除するか、モバイルアプリをアンインストールすれば消えます。エクスポートしたファイルは、保存した場所に残ります。',
  'privacyPage.third.posthog.title': '利用統計 · PostHog',
  'privacyPage.third.posthog.body': '製品の改善のため、PostHog（米国）で利用統計とエラーレポートを集めています。たとえば、どのプロバイダを使ったか、セッションの長さ、エラー、端末とオペレーティングシステム、そしてブラウザ拡張機能の場合は、拡張機能を開いたページのホスト名です。ログインすると、これらはあなたのアカウント ID、メールアドレス、登録時に入力した名前と結び付けられます。会議の内容が含まれることはありません。現在、アプリ内にこれをオフにするスイッチはありません。',
  'privacyPage.third.stripe.title': '支払い · Stripe',
  'privacyPage.third.stripe.body': 'チャージの決済は Stripe が処理し、カード番号の全桁は Stripe にだけ渡ります。私たちがそれを見ることはありません。支払いの照合と確認のため、Stripe から一部の支払い情報を受け取ります。たとえば、支払者の氏名、メールアドレス、請求先住所、カードのブランドと下4桁です。',
  'privacyPage.stored.title': '保存するものと、その期間',
  'privacyPage.stored.lead': '以下のデータが私たちのサーバーに保存されるのは、Kizuna AI アカウントを使う場合だけです。',
  'privacyPage.stored.col.data': 'データ',
  'privacyPage.stored.col.why': '必要な理由',
  'privacyPage.stored.col.keep': '保存期間',
  'privacyPage.stored.email.data': 'メールアドレスと名前',
  'privacyPage.stored.email.why': 'ログイン、アカウントの確認、試用クレジットの付与',
  'privacyPage.stored.email.keep': 'アカウントがある間',
  'privacyPage.stored.logins.data': 'ログイン記録（IP アドレス、端末、おおよその位置）',
  'privacyPage.stored.logins.why': 'ログイン状態の維持と、アカウントの問題の調査',
  'privacyPage.stored.logins.keep': 'アカウントを削除するまで',
  'privacyPage.stored.abuseIps.data': '不正利用防止用の IP 記録',
  'privacyPage.stored.abuseIps.why': '同じ人が試用クレジットを二度受け取るのを防ぐこと',
  'privacyPage.stored.abuseIps.keep': '最後に確認されてから90日',
  'privacyPage.stored.trial.data': '試用クレジットの記録（メールアドレスの一方向ハッシュ。受け取りが拒否された場合は、一致した IP アドレスも）',
  'privacyPage.stored.trial.why': '同じメールアドレスや同じ人が試用クレジットを再び受け取るのを防ぐこと',
  'privacyPage.stored.trial.keep': '長期間保管（アカウントを削除した後も残ります）',
  'privacyPage.stored.billing.data': '残高、チャージ、使用量。あわせて、支払いの確認に使う Stripe からの支払い情報',
  'privacyPage.stored.billing.why': '課金、支払いの確認、アカウント画面でのあなたへの表示',
  'privacyPage.stored.billing.keep': 'アカウントがある間。削除後は、適用される現地の法令の定めに従って保存',
  'privacyPage.stored.feedback.data': 'フィードバック',
  'privacyPage.stored.feedback.why': 'あなたへの返信',
  'privacyPage.stored.feedback.keep': 'サポート用メールボックスに保管',
  'privacyPage.stored.deletion': 'アカウントは、アカウント画面からいつでも削除できます。削除すると、メールアドレス、名前、ログイン記録、連携したログイン方法、複製した音声が消去されます。不正利用防止用の IP 記録は、上の表の期間に従って自動で消去されます。試用クレジットの記録は、試用クレジットを再び受け取れないように保存されます。課金記録（支払いの確認に使う Stripe からの支払い情報を含みます）は、法令の定めに従って保存されます。',
  'privacyPage.check.title': '私たちの言葉をうのみにする必要はありません',
  'privacyPage.check.lead': 'Sokuji はオープンソース（AGPL-3.0）です。会議の内容の行き先についてこのページに書いたことは、技術のわかる人なら誰でも確かめられます。',
  'privacyPage.check.code.title': 'コードを読む',
  'privacyPage.check.code.body': '会議の内容の送り先はすべて src/providers/、src/lib/edge-tts/、src/lib/bing-translator/ に書かれていて、そのどれも Kizuna AI ではありません（上で説明した、音声の複製用サンプルを除きます）。',
  'privacyPage.check.network.title': '通信を見る',
  'privacyPage.check.network.body': 'ブラウザの開発者ツールかプロキシを開いた状態で会議をしてみてください。会議の内容を運ぶリクエストは、すべて AI プロバイダへ直接向かっています。',
  'privacyPage.check.offline.title': 'ネットワークを切って動かす',
  'privacyPage.check.offline.body': 'オンデバイスモデルだけを使う場合、モデルをダウンロードしたあとなら、ネットワークを切っても Sokuji は動き続けます。',
  'privacyPage.promise.title': '私たちの約束',
  'privacyPage.promise.noSale': 'あなたのデータを販売することも、貸し出すこともしません。上に挙げたサービスと、正式なプライバシーポリシーに記載したインフラ事業者以外の誰とも共有しません。',
  'privacyPage.promise.noTraining': 'あなたのデータでモデルを学習させることも、会議を分析することもしません。そもそも会議の内容を受け取っていないからです。',
  'privacyPage.promise.trust': 'アカウントサーバーはオープンソースではないため、この部分は私たちを信頼してもらうしかありません。信頼したくなければ、Sokuji はログインしなくてもまるごと使えます。自分の鍵を使うか、自分のマシンで動かしてください。',
  'privacyPage.end.note': 'これはわかりやすい言葉でまとめた要約です。法的拘束力のある条項は、正式なプライバシーポリシーにあります。',
  'privacyPage.end.cta': 'プライバシーポリシー',
  'download.page.title': 'Sokuji を入手',
  'download.page.lead': 'Windows、macOS、Linux のいずれでもフリーでオープンソースです。初回起動の前に求められるものはプラットフォームごとに少しずつ違います。このページはそれを書いたものです。',
  'download.desktop.title': 'デスクトップ',
  'download.desktop.lead': 'デスクトップアプリはシステムにマイクとして登録されます。マイクを選べるアプリなら何でも使えます。',
  'download.linux.note': 'pulseaudio-utils が必要',
  'download.windows.note': 'VB-CABLE は別途インストール',
  'download.macos.note': '署名・公証済み · インストール手順を読む',
  'download.macos.noteLead': '署名・公証済み ·',
  'download.ext.addEdge': 'Edge に追加',
  'download.ext.addChrome': 'Chrome に追加',
  'download.macos.bodyBefore': '音声ドライバはインストーラに同梱されています。Apple シリコンと Intel の両方に対応。アプリ自体は',
  'download.macos.signed': '署名され、Apple の公証を受けています',
  'download.macos.bodyAfter': '。ほかの Mac アプリと同じようにインストールできます。',
  'download.need.linuxBefore': 'PulseAudio か PipeWire が動いていること、そして',
  'download.need.linuxMid': '（',
  'download.ext.title': 'ブラウザ拡張機能',
  'download.ext.lead': 'システムに入れるものはなく、音声の取り回しを整える必要もありません。会議サイト向けに作られていて、ページそのものに仮想マイクを差し込めます。',
  'download.ext.browser': 'Chrome と Edge',
  'download.ext.browserBody': 'Chromium 116 以降、サイドパネル API。ストアからワンクリックで入ります。',
  'download.ext.worksOn': '対応サイト',
  'download.ext.elsewhere': 'それ以外はデスクトップアプリで',
  'download.need.title': '入れる前に',
  'download.need.col': '必要なもの',
  'download.need.linux': 'PulseAudio か PipeWire が動いていること、そして pactl のための pulseaudio-utils',
  'download.need.windows': '音声の取り回しに VB-CABLE。インストーラが案内します',
  'download.need.macos': '同梱の SokujiVirtualAudio ドライバ',
  'download.need.any': 'どのプラットフォームでも',
  'download.need.anyBody': 'プロバイダをひとつ。端末上の推論、自分の API キー、あるいは Kizuna AI アカウント。インストール自体にはどれも要りません。',
  'download.need.nothing': 'なにも',
  'download.need.nothingBody': 'ダウンロードにも、インストールにも、自分の鍵や端末上での利用にも、アカウントは要りません。',
  'download.linux.title': 'Linux',
  'download.linux.body': 'Debian パッケージまたは AppImage、x64 と arm64。仮想マイクは Sokuji 自身が PulseAudio か PipeWire を通じて作ります。ほかに入れるものはありません。',
  'download.windows.title': 'Windows',
  'download.windows.body': 'コード署名済みなので、よくある「発行元不明」の警告なしにインストールできます。フリーソフトウェアを無償で署名してくれる SignPath Foundation のおかげです。音声の取り回しは VB-CABLE を通ります。',
  'download.macos.title': 'macOS',
  'download.macos.body': '音声ドライバはインストーラに同梱されています。アプリ自体は署名され、Apple の公証を受けているので、ほかの Mac アプリと同じようにインストールできます。',
  'home.platform.linux.body': '仮想マイクは Sokuji 自身が PulseAudio か PipeWire を通じて作ります。ほかに入れるものはありません。',
  'home.platform.cta': 'ダウンロード',
  'home.platform.windows.body': 'コード署名済みなので、いつもの警告なしにインストールできます。無償で署名してくれている SignPath Foundation のおかげです。音声の取り回しは VB-CABLE を使います。',
  'home.platform.macos.body': '音声ドライバはインストーラに同梱されています。アプリは署名され、Apple の公証を受けているので、ほかの Mac アプリと同じようにインストールできます。',
  'home.faq.title': 'なぜこの作りなのか',
  'home.faq.lead': 'よくいただく質問の多くは、実のところ製品の設計判断についての質問です。ここに率直にお答えします。',
  'faq.audio.q': '音声や会議の内容は御社に渡りますか。',
  'faq.audio.a': 'いいえ。音声、画面の画像、文字起こし、翻訳はあなたの端末から、選んだAIプロバイダへ直接送られます。鍵が Kizuna AI アカウント経由でも同じです。私たちは短時間だけ有効な鍵を発行して使用量を数えるだけで、あとはベンダー側の仕事です。保持しているのはアカウントに必要な情報（メールアドレス、ログイン記録、残高、使用量）で、会議の内容は一切含みません。完全な一覧はプライバシーのページにあります。',
  'faq.other.q': 'なぜ相手側は何も入れなくてよいのですか。',
  'faq.other.a': '言語を越えるのは「伝わりたい側」の仕事で、聞いている全員の仕事ではない、と考えているからです。Sokuji はあなたの側で翻訳し、仮想マイクから話します。相手に届くのはごく普通の通話音声です。',
  'faq.service.q': '御社の AI サービスを使わなければなりませんか。',
  'faq.service.a': 'いいえ。対応ベンダーの鍵を自分で持ち込む、端末上で無料で動かす、のどちらでも構いません。Kizuna AI アカウントは、開発者コンソールを触りたくない人のためにあるだけで、囲い込むためのものではありません。',
  'faq.cost.q': 'Sokuji の費用は。',
  'faq.cost.a': 'Sokuji はフリーでオープンソース、端末上での推論もそのまま無料です。費用がかかるのは任意の Kizuna AI アカウントだけで、実際に使った分の従量制です。月額サブスクではないので、使わなかった月はゼロ円です。チャージした残高の有効期限は1年ですが、これは会計上の区切りであって、使わせるための仕掛けではありません。自分の鍵を使うかローカルで動かすなら、私たちに払うものは一切ありません。',
  'faq.believe.q': 'なぜそれを信じられるのですか？',
  'faq.believe.a': '半分は信じないでください。だから線を引きます。アプリは AGPL-3.0 ライセンスで、音声の行き先を決めているのはそのアプリです。すべて github.com/kizuna-ai-lab/sokuji にあり、自分でビルドでき、通信も覗けます。アカウント側のサービスはオープンソースではないので、アカウントと使用量のデータをどう扱うかは約束であって証明ではありません。その線はぼかさず、はっきり引いておきます。',
  'faq.youtube.q': 'YouTube をリアルタイム翻訳するのに使えますか？',
  'faq.youtube.a': 'できますし、止めるものは何もありません。Sokuji はマシンに届く音声なら動画でも翻訳します。ただ、そこを狙って作ってはいません。10万人が見る動画をその都度ライブ翻訳するのは、同じ仕事を10万回やることです。投稿者が一度訳せば、一度で済みます。実際、作り手がその翻訳を用意するのに Sokuji を使っています。',
  'faq.local.q': 'ローカルAIはオフライン時の代替にすぎませんか？',
  'faq.local.a': 'いいえ。最初から一級の選択肢で、ずっと無料です。モデルは小さくなり続け、ランタイムは良くなり続け、民生用アクセラレータは速くなり続けています。AI を使うためだけに、自分の会話を大手AI企業に渡さなければならない理由はありません。',
  'faq.platforms.q': 'Sokuji は macOS と Windows で署名されていますか？',
  'faq.platforms.a': 'はい。Windows のインストーラーは、フリーソフトウェアに無償で署名している SignPath Foundation のおかげで署名されています。macOS 版はバージョン 0.46.5 から Apple Developer ID で署名され、Apple の公証を受けています。',
  'home.during.title': '通話中に何をしているか',
  'home.during.lead': '音声をモデルに流すだけなら誰にでもできます。会議のあいだずっと聞き取れる状態を保つこと——遅れずについていく、話し終わったかを見極める、自分の声を返さない——それは音響のエンジニアリングです。',
  'feat.voice.t': '自分の声で話す',
  'feat.voice.b': '短いクリップを一度録れば、訳された発話が既製の声ではなくあなたの声で届きます。プロバイダの音声ライブラリから選ぶこともできます。選べる声は利用中のプロバイダによって変わります。',
  'feat.tempo.t': '話速の自動調整',
  'feat.tempo.b': '同じ内容でも言語によって所要時間は違うため、一定の速度では文ごとに訳が遅れていきます。Sokuji は追いつく分だけ話速を上げます。',
  'feat.turn.t': '意味による発話区切り',
  'feat.turn.b': '単なる沈黙ではなく、考えが一区切りついたことを待ちます。文の途中で切られません。',
  'feat.terms.t': 'あなたの言葉、あなたの用語',
  'feat.terms.b': 'システム指示により、人名・製品名・社内用語が意味の崩れた訳になるのを防ぎます。',
  'feat.overlay.t': '字幕オーバーレイ',
  'feat.overlay.b': 'ドラッグとリサイズができる別ウィンドウか、会議ページ自体に重ねる字幕か。',
  'feat.offline.t': 'ネットワークを切っても動く',
  'feat.offline.b': 'Sokuji が GPU を検出し、それ向けの推論エンジンをダウンロードして、認識・翻訳・音声合成をあなたの端末で実行します。鍵もアカウントも計測もありません。 ここではオンデバイスが一級の選択肢であって、接続が切れたときの代替ではありません。',
  'home.during.also': 'ほかに、押している間だけ翻訳、ノイズ抑制、エコーキャンセル、途中経過の文字起こしの翻訳、音声バッファの調整、セッション中のデバイス切り替え、仮想マイクそのもの、会話の .txt / .json 書き出し。',
  'home.carry.title': '当社が引き受けること、あなたの手元に残ること',
  'home.carry.lead': 'Sokuji は無償かつオープンソースで、その方針は変わりません。それとは別に、Kizuna AI アカウントはいくつかの AI ベンダーについて鍵の保持と代金の精算を引き受けます——開発者コンソールを触りたくない方のために。モデルを動かすのは当社ではありませんし、そもそも一度も使わなくて構わないサービスです。どの便利さの隣にも、必ず出口を置いてあります。',
  'carry.ours': '当社が引き受ける',
  'carry.yours': 'いつでも自分でできる',
  'carry.account.t': 'アカウント一つ、コンソール不要',
  'carry.account.b': '当社が資格情報を発行し代金を精算します。モデルを動かすのは引き続き Soniox または Qwen です。',
  'carry.bill.t': '請求は一本化、従量制',
  'carry.bill.b': '決済まわりの配管を当社が引き受け、実際に使った分だけ請求します。',
  'carry.cloud.t': '必要なときはクラウドのモデル',
  'carry.cloud.b': '現時点で最も速く最も正確な翻訳を、必要なときだけ。',
  'carry.packaged.t': 'パッケージ済みのアプリ',
  'carry.packaged.b': 'デスクトップ版とブラウザ拡張を、数クリックで導入できます。',
  'carry.ownkey.t': '自分の鍵を使う',
  'carry.ownkey.b': '10以上のプロバイダに対応し、それぞれスクリーンショット付きの手順書があります。',
  'carry.direct.t': 'プロバイダへ直接支払う',
  'carry.direct.b': '当社を完全に外して構いません。Kizuna AI アカウントなしでも Sokuji は動きます。',
  'carry.machine.t': '自分の端末で動かす',
  'carry.machine.b': '端末内蔵の推論。無償で、オフラインでも動き、第一候補として同梱しています。',
  'carry.source.t': 'ソースからビルドする',
  'carry.source.b': 'クローンして、読んで、変更して、自分のビルドを配る。AGPL-3.0 です。',
  'stat.langs': '翻訳できる言語',
  'stat.ui': 'アプリの表示言語',
  'stat.sites': '拡張機能が対応する会議サイト',
  'stat.providers': 'AIプロバイダ、独自エンドポイントも可',
  'home.platforms.title': 'どのプラットフォームでも。そして、それぞれが求めるもの',
  'download.builds': 'ビルド',
  'download.readGuide': 'インストール手順を読む',
  'home.install.flowLabel': '訳されたあなたの声が仮想マイクを通って相手に届くまで',
  'home.routing.title': 'あなたの会議の内容は当社を経由しません',
  'home.routing.lead': 'Kizuna AI アカウントの鍵を使う場合でも、音声、画面の画像、翻訳はあなたの端末からモデルを動かすベンダーへ直接向かいます。選んだモデルが端末内蔵のものなら、どこへも出ません。当社が行うのはアカウント管理と課金だけで、保存しているのはアカウントと利用量のデータであり、会議の内容は一切含みません。',
  'routing.you': 'あなた',
  'routing.sokuji': 'sokuji（あなたの端末上）',
  'routing.provider': '選んだ AI プロバイダ',
  'routing.providerNote': 'クラウド、または自分の端末',
  'routing.up': 'あなたの音声（上り）',
  'routing.down': '訳文（戻り）',
  'routing.onDevice': '端末内蔵なら、どちらもここから出ない',
  'routing.mic': '仮想マイク',
  'routing.app': '任意のアプリ',
  'routing.them': '相手',
  'routing.kizuna': 'Kizuna AI',
  'routing.kizunaCarries': '短時間有効な鍵・従量課金・会議の内容なし',
  'routing.label': '会議の内容はあなたの端末と選んだプロバイダの間を往復し、Kizuna AI は鍵、あなたのアカウント、利用量だけを運ぶ別の枝にいる',
  'routing.or': 'または',
  'scenarios.page.title': '何をしたいですか。',
  'scenarios.page.lead': 'これらはプリセットであって、閉じ込められるモードではありません。設定される内容はどれも後から変更できます。',
  'scenarios.axes.title': 'それぞれが決めていること',
  'scenarios.axes.lead': 'どれも同じ三つの決定に、違う答えを出しているだけです。誰の音声を訳すか、その結果を声に出すか、そして画面に何が残るか。',
  'axis.sets': 'この設定が決めること',
  'scenarios.whoPicks': '向いているのは：',
  'scenarios.anyApp.lead': '「任意のアプリ」は文字どおりです。',
  'scenarios.anyApp.body': '出ていく側では Sokuji はただのマイクなので、マイクを選べるものなら何でも訳された声を運べます。ブラウザのタブ、録音ソフト、配信ソフト、ゲーム。入ってくる側ではマシンが鳴らしているものすべて、システム音声も含めて扱うので、動画も配信も録画も通話とまったく同じように動きます。',
  'scenarios.fit.title': 'すべてのプロバイダがすべてのシナリオをこなせるわけではありません',
  'scenarios.fit.lead': '鍵になるのは二点です。一つめは、そのプロバイダが声を出せるか、そして黙らせておけるか。テキストしか返さないものは通話に発話できず、必ず音声で返すものは字幕だけに留めておけません。いま Sokuji が提供しているプロバイダはどれも両方できますが、この確認は今後のプロバイダのために残しています。二つめは対面です。1 本のマイクを 2 人で使うには話し手を聞き分けられるプロバイダが必要で、それができるのは Soniox だけです（自分のキー、または KizunaAI 経由）。Sokuji はプロバイダを選んだ時点でこの二点を確認するので、こなせないシナリオは通話中に判明するのではなく、その前に閉じられます。',
  'scenarios.fit.available': '使える',
  'scenarios.fit.unavailable': 'そのプロバイダでは使えない',
  'scenarios.fit.note': '「相手の話を理解する」だけはどこでも成立します。最初は文字だけで、相手の側が読み上げられるのは「自分に聞こえる翻訳」をオンにしたときだけです。いちばん右の列は Soniox（自分のキー、または KizunaAI 経由）です。',
  'provider.textOnly': 'テキストしか\n返さない',
  'provider.alwaysSpeaks': '必ず\n発話する',
  'provider.either': 'どちらも\nできる',
  'provider.faceToFace': 'どちらもでき\n対面もできる',
  'spoken.yesVoice': 'はい — 合成音声を通話に流します',
  'spoken.yesBoth': 'はい — あなたの側は通話へ、相手の側はあなたへ',
  'spoken.yesEarbuds': 'はい — それぞれが片耳のイヤホンで相手の訳を聞きます',
  'spoken.optional': 'いいえ — 「自分に聞こえる翻訳」をオンにしない限り',
  'flow.you': 'あなた',
  'flow.subtitles': '字幕',
  'flow.anyAppSystem': '任意のアプリ\nまたはシステム音声',
  'flow.yourHeadphones': 'あなたのヘッドホン',
  'flow.yourEarbud': 'あなたのイヤホン',
  'flow.theirEarbud': '相手のイヤホン',
  'flow.sameScreen': '同じ画面',
  'scenario.understand-others.who': 'あなたが聞き手で、話し手が歩み寄ってくれるわけではないとき。',
  'scenario.be-heard.who': 'その場の共通語ではない言語で話す人。しかも、その通話を立てたのが自分とはかぎらないとき。',
  'scenario.subtitle-myself.who': '発表者や配信者。自分の声に別の声が重なるより、字幕のほうがましな場面。',
  'scenario.two-way-voice.who': 'どちらの側も共通の言語を持たない、本当のやりとり。',
  'scenario.two-way-text.who': '録画される会議、議事録づくり、あるいは音を足すことが歓迎されない場。',
  'scenario.face-to-face-voice.who': '同じ部屋にいて共通の言語を持たない 2 人。デスクや窓口、食卓で。',
  'scenario.face-to-face-text.who': '同じ部屋で、耳に声を足したくないとき。あるいは相手が自分のスマートフォンで読みたいとき。',
  'axis.whoseAudio': 'どちらの音声',
  'axis.spokenAloud': '声に出す',
  'axis.onScreen': '画面に出る',
  'audio.speaker': 'あなたのマイク',
  'audio.participant': '相手側',
  'audio.both': '両方',
  'audio.besideMe': '2 人とも、1 本のマイクで',
  'spoken.yes': 'はい',
  'spoken.no': 'いいえ',
  'scenario.understand-others.onScreen': '相手の発言の訳',
  'scenario.understand-others.flow': '相手が話す → あなたが読む',
  'scenario.be-heard.onScreen': 'あなたの言葉と訳を並べて',
  'scenario.be-heard.flow': 'あなたが話す → 相手が聞く',
  'scenario.subtitle-myself.onScreen': '訳文（聴衆向け）',
  'scenario.subtitle-myself.flow': 'あなたが話す → 相手が読む',
  'scenario.two-way-voice.onScreen': '原文と訳、両側とも',
  'scenario.two-way-voice.flow': '双方向 · どちらも音声',
  'scenario.two-way-text.onScreen': '原文と訳、両側とも',
  'scenario.two-way-text.flow': '双方向 · 文字だけ',
  'scenario.face-to-face-voice.onScreen': '両側とも。各行に、どちらの耳で流れるかの印',
  'scenario.face-to-face-voice.flow': 'マイク 1 本 · イヤホンを片耳ずつ',
  'scenario.face-to-face-text.onScreen': '原文と訳、両側とも',
  'scenario.face-to-face-text.flow': 'マイク 1 本 · 文字だけ',
  'scenario.understand-others.title': '相手の話を理解する',
  'scenario.understand-others.body': 'オンライン会議・授業・講演・動画・配信——聞こえる内容の翻訳をリアルタイムで読みます。',
  'scenario.understand-others.detail': 'オンライン会議・授業・講演・動画・配信——聞こえる内容の翻訳をリアルタイムで読みます。「自分に聞こえる翻訳」をオンにしない限り、読み上げはありません。',
  'scenario.be-heard.title': '会議で自分の話を伝える',
  'scenario.be-heard.body': '相手には仮想マイク経由で翻訳音声が届きます。',
  'scenario.be-heard.detail': '相手には仮想マイク経由で翻訳音声が届きます。相手側はインストールもプラグインも不要で、字幕を読む必要もありません。',
  'scenario.subtitle-myself.title': '自分の話に字幕を付ける',
  'scenario.subtitle-myself.body': '講演・配信・プレゼン——視聴者は翻訳字幕を読みます。音声は生成しません。',
  'scenario.subtitle-myself.detail': '講演・配信・プレゼン——視聴者は翻訳字幕を読みます。音声は生成しません。あなたは自分の声のまま話し続けます。',
  'scenario.two-way-voice.title': 'オンラインで双方向に会話',
  'scenario.two-way-voice.body': '相手はあなたの翻訳音声を聞き、あなたは相手の字幕を読めて、翻訳音声を聞くこともできます。',
  'scenario.two-way-voice.detail': '相手はあなたの翻訳音声を聞き、あなたは相手の字幕を読めて、翻訳音声を聞くこともできます。デスクトップアプリでは、「相手の音声」が 1 つのアプリ（会議アプリなど）のときに相手の翻訳が読み上げられます。システム全体の音を取り込んでいるときは字幕で読むだけです。',
  'scenario.two-way-text.title': 'オンラインで双方向に会話（字幕のみ）',
  'scenario.two-way-text.body': '二か国語字幕や議事録——双方ともテキストで、合成音声は使いません。',
  'scenario.two-way-text.detail': '二か国語字幕や議事録——双方ともテキストで、合成音声は使いません。',
  'scenario.face-to-face-voice.title': '対面で会話',
  'scenario.face-to-face-voice.body': '2 人が 1 台のパソコンでそれぞれの言語で話し、各自が片耳のイヤホンで自分の言語の翻訳だけを聞きます。',
  'scenario.face-to-face-voice.detail': '2 人が 1 台のパソコンでそれぞれの言語で話し、各自が片耳のイヤホンで自分の言語の翻訳だけを聞きます。既定では、あなたのイヤホンが左チャンネル、相手のイヤホンが右チャンネルです。',
  'scenario.face-to-face-text.title': '対面で会話（字幕のみ）',
  'scenario.face-to-face-text.body': '2 人で同じ画面を見るか、相手がスマートフォンで LAN 字幕ページを開きます。',
  'scenario.face-to-face-text.detail': '2 人で同じ画面を見るか、相手がスマートフォンで LAN 字幕ページを開きます。LAN 字幕ページはデスクトップアプリだけの機能です。',
  'nav.install': 'インストール',
  'nav.platforms': 'プラットフォーム',
  'nav.platformsOverview': '概要',
  'nav.aiProviders': 'AIプロバイダー',
  'nav.kizunaAI': 'KizunaAI',
  'nav.kizunaAIFeatures': 'KizunaAI の機能',
  'nav.providersOverview': '概要',
  'nav.privacy': 'プライバシー',
  'nav.terms': '利用規約',
  'footer.terms': '規約',
  'nav.feedback': 'フィードバック',
  'nav.github': 'GitHub',

  // Tutorials
  'tutorials.zoom': 'Zoom',
  'tutorials.googleMeet': 'Google Meet',
  'tutorials.teams': 'Microsoft Teams',
  'tutorials.discord': 'Discord',
  'tutorials.slack': 'Slack',
  'tutorials.jitsi': 'Jitsi Meet',
  'tutorials.whereby': 'Whereby',
  'tutorials.gather': 'Gather',
  'tutorials.openai': 'OpenAI セットアップ',
  'tutorials.gemini': 'Gemini セットアップ',
  'tutorials.palabraai': 'PalabraAI セットアップ',
  'tutorials.volcengineAST2': 'Doubao AST 2.0 セットアップ',
  'tutorials.soniox': 'Soniox セットアップ',
  'tutorials.qwen': 'Qwen LiveTranslate セットアップ',
  'tutorials.kizunaQuickStart': 'クイックスタート',
  'tutorials.twoWayMeeting': '会議の双方向翻訳',
  'tutorials.understandOthers': '会議・動画の理解',
  'tutorials.beUnderstood': '会議での発言',
  'tutorials.subtitleMySpeech': '講演・配信の字幕',
  'tutorials.twoWaySubtitles': '双方向の字幕',
  'tutorials.faceToFace': '対面での会話',
  'tutorials.kizunaVoices': '音声と声の複製',
  'tutorials.kizunaVocabulary': 'カスタム語彙',
  'tutorials.kizunaRegion': '処理リージョン',
  'tutorials.kizunaLatency': '文の区切りと遅延',
  'tutorials.kizunaBilling': '残高と料金',
  'tutorials.localInference': '無料（デバイス上で実行）セットアップ',
  'tutorials.localModels': 'ローカルモデルとライセンス',
  'tutorials.realtimeTester': 'API テスター',

  // Landing Page
  'landing.title': 'Sokuji',
  'landing.slogan.line1': '自分の言葉で話す。',
  'landing.slogan.line2': '相手の言葉で伝わる。',
  'landing.tagline': 'AI駆動のリアルタイム音声翻訳',
  'landing.subtitle': 'あなたの声は相手の言語で届きます。相手の発言はあなたの言語で返ってきます — 字幕で、または読み上げで。Sokuji はあなたと会議アプリのあいだに入る仮想マイクなので、設定はあなた側だけ。相手はいつも通り話すだけで、インストールも参加リンクも要りません。',
  'landing.trust': 'フリー＆オープンソース · オンデバイスAI · サブスクなし',
  'landing.cta.extension': 'ブラウザ拡張機能を入手',
  'landing.cta.desktop': '無料でダウンロード',
  'landing.cta.docs': 'ドキュメントを見る',

  // Platform Selection
  'platform.title': 'プラットフォームを選択',
  'platform.extension.title': 'ブラウザ拡張機能',
  'platform.extension.desc': 'オンライン会議向け（Google Meet、Zoom、Teamsなど）',
  'platform.extension.chrome': 'Chrome ウェブストア',
  'platform.extension.edge': 'Edge アドオン',
  'platform.extension.brave': 'Brave（準備中）',
  'platform.desktop.title': 'デスクトップアプリケーション',
  'platform.desktop.desc': 'すべてのシナリオに対応 - あらゆるウェブサイト、アプリ、システム音声',
  'platform.desktop.windows': 'Windows インストーラー (.exe)',
  'platform.desktop.macos.arm': 'macOS インストーラー - Apple Silicon (-arm64.pkg)',
  'platform.desktop.macos.intel': 'macOS インストーラー - Intel (-x64.pkg)',
  'platform.desktop.linux': 'Linux パッケージ (.deb)',

  // Installation Guides
  'install.title': 'インストールガイド',
  'install.windows': 'Windows インストールガイド',
  'install.macos': 'macOS インストールガイド',
  'install.linux': 'Linux インストールガイド',

  // Docs Home
  'docs.title': 'ドキュメント',
  'docs.subtitle': 'Sokujiのインストールと使用方法を学ぶ',
  'docs.gettingStarted': 'はじめに',
  'docs.installation': 'インストール',
  'docs.configuration': '設定',
  'docs.resources': 'リソース',
  'docs.card.participantAudio': '相手の発言を翻訳します。会議アプリ、ブラウザーのタブ、またはシステム全体の音声から。',
  'docs.card.subtitleMode': '会議や動画、スライドの上に置ける細長いフローティング字幕バー。',

  // Supported Sites
  'sites.title': 'サポートされているウェブサイト',
  'sites.subtitle': 'Sokuji拡張機能は以下のビデオ会議およびコミュニケーションプラットフォームと互換性があります。',
  'sites.howToUse.title': '使用方法',
  'sites.howToUse.desc': 'サポートされているプラットフォームで、プラットフォームのオーディオ設定でマイク入力として「Sokuji Virtual Microphone」を選択するだけです。Sokujiがあなたの音声をリアルタイムで翻訳します。',
  'sites.needHelp.title': 'お困りですか？',
  'sites.needHelp.desc': '特定のプラットフォームで問題が発生した場合は、GitHubリポジトリでトラブルシューティングガイドとサポートをご確認ください。',
  'sites.visitPlatform': 'プラットフォームを開く',
  'sites.tutorial': 'チュートリアル',

  // Site Cards
  'sites.meet.name': 'Google Meet',
  'sites.meet.url': 'meet.google.com',
  'sites.meet.features': '',

  'sites.teams.name': 'Microsoft Teams',
  'sites.teams.url': 'teams.live.com / teams.microsoft.com',
  'sites.teams.features': 'クロスプラットフォーム互換性|個人版とエンタープライズ版',

  'sites.gather.name': 'Gather',
  'sites.gather.url': 'app.gather.town',
  'sites.gather.features': '空間オーディオサポート',

  'sites.whereby.name': 'Whereby',
  'sites.whereby.url': 'whereby.com',
  'sites.whereby.features': 'ブラウザベースの会議',

  'sites.discord.name': 'Discord',
  'sites.discord.url': 'discord.com',
  'sites.discord.features': 'ボイスチャンネルサポート',

  'sites.slack.name': 'Slack',
  'sites.slack.url': 'app.slack.com',
  'sites.slack.features': 'Huddlesと通話サポート',

  'sites.jitsi.name': 'Jitsi Meet',
  'sites.jitsi.url': 'meet.jit.si',
  'sites.jitsi.features': 'オープンソース会議サポート',

  'sites.zoom.name': 'Zoom',
  'sites.zoom.url': 'app.zoom.us',
  'sites.zoom.features': 'Webクライアントサポート',

  // AI Providers
  'providers.title': 'サポートされているAIプロバイダー',
  'providers.subtitle': 'Sokujiはリアルタイム音声翻訳のために複数のAIプロバイダーをサポートしています。各プロバイダーは異なる機能、モデル、価格体系を提供しています。無料モードはAPIキー不要で、デバイス上で無料で動作します（インターネット接続が必要なのは一部の音声だけです）。',
  'providers.setup.title': 'セットアップ手順',
  'providers.setup.desc': 'クラウドAIプロバイダーを使用するには、プロバイダーのウェブサイトからAPIキーを取得し、Sokujiの設定パネルで設定してください。無料モードはAPIキー不要 — モデルをダウンロードするだけで翻訳を開始できます。',
  'providers.choosing.title': 'プロバイダーの選び方',
  'providers.needHelp.title': 'お困りですか？',
  'providers.needHelp.desc': 'セットアップガイド、トラブルシューティング、プロバイダー比較については、GitHubリポジトリをご覧ください。',
  'providers.docs': 'ドキュメント',
  'providers.setupTutorial': 'セットアップチュートリアル',

  // Provider Cards
  'providers.openai.name': 'OpenAI',
  'providers.openai.type': 'リアルタイムオーディオAPI',
  'providers.openai.features': 'GPT-4o Realtime Previewモデル|8種類のプレミアム音声オプション|高度なターン検出モード|内蔵ノイズリダクション|60以上の言語をサポート|カスタムプロンプト用テンプレートモード',
  'providers.openai.desc': '高品質な音声合成と高度な機能に最適',

  'providers.gemini.name': 'Google Gemini',
  'providers.gemini.type': 'Gemini Live API',
  'providers.gemini.features': 'Gemini 2.0 Flash Liveモデル|30種類のユニークな音声パーソナリティ|自動ターン検出|35以上の言語と地域バリアント|内蔵文字起こし|高トークン制限 (8192)',
  'providers.gemini.desc': '多言語サポートと自動処理に最適',

  'providers.palabra.name': 'PalabraAI',
  'providers.palabra.type': 'WebRTC翻訳サービス',
  'providers.palabra.features': 'リアルタイムWebRTC翻訳|60以上のソース言語|40以上のターゲット言語|低遅延ストリーミング|自動音声処理|ライブ翻訳に特化',
  'providers.palabra.desc': '最小限の遅延でリアルタイム翻訳に最適化',



  'providers.volcengineAST2.name': 'Doubao AST 2.0',
  'providers.volcengineAST2.type': '音声から音声への翻訳',
  'providers.volcengineAST2.features': 'エンドツーエンドの音声から音声への翻訳|声の複製、または 500 以上のライブラリから選ぶ固定の声|低遅延の同時通訳|20 言語に加えて広東語と呉語、うち 8 言語は音声出力に対応|アプリ ID + アクセストークン、または API キー|ByteDanceクラウドインフラ',
  'providers.volcengineAST2.desc': 'Doubaoの音声から音声への同時通訳。話者の声を複製するか、選んだ固定の声で話します',
  'providers.soniox.name': 'Soniox',
  'providers.soniox.type': '音声から音声への翻訳',
  'providers.soniox.features': 'リアルタイム音声から音声への翻訳|1回のAPI呼び出しで60以上の言語を文字起こしと翻訳|自動言語検出|200種類の内蔵音声と声の複製|音声翻訳または字幕のみ|対面会話と話者ラベル|Sonioxクラウドインフラ',
  'providers.soniox.desc': '60以上の言語に対応した Soniox のリアルタイム音声から音声への翻訳、自動言語検出付き',

  'providers.qwen.name': 'Qwen LiveTranslate',
  'providers.qwen.type': '音声から音声への同時通訳',
  'providers.qwen.features': '1回のストリーミングセッションでリアルタイム同時通訳（qwen3.8-livetranslate-flash-realtime）|60言語に対応、うち29言語は音声出力に対応、ソース言語を自動検出|47種類のプリセット音声、または録音不要でその場で複製する自分の声|名称や用語の優先訳語|音声翻訳または字幕のみ|QwenCloud（国際版）または千问云（中国本土版）で取得したご自身のキー、またはKizuna AIアカウント|Alibaba Cloudインフラ、デスクトップアプリとブラウザ拡張機能に対応',
  'providers.qwen.desc': '自分の声をその場で複製して話せる、60言語対応の同時通訳',

  'providers.localInference.name': '無料',
  'providers.localInference.type': 'オンデバイスAI（エッジ）',
  'providers.localInference.features': '完全オフライン — APIキーもインターネットも不要|40以上のASRモデルで99以上の言語をカバー|55以上の翻訳言語ペア + Qwen LLM|53言語の136のTTSモデル|CPU (WASM) とWebGPUアクセラレーション|プライバシー最優先 — すべてのデータはデバイス上に保持',
  'providers.localInference.desc': 'デバイス上ですべてを実行し、データが外部に出ない — プライバシーを重視するユースケースに最適',

  // Privacy Policy
  'privacy.title': 'プライバシーポリシー',
  'privacy.lastUpdated': '最終更新日：2026年11月3日',
  'privacy.intro.title': 'はじめに',
  'privacy.intro.content': '本プライバシーポリシーは、Kizuna AI Lab（以下「当社」といいます）が、デスクトップアプリケーション、モバイルアプリケーション、ブラウザ拡張機能、sokuji.kizuna.aiのウェブサイトおよびKizuna AIアカウントを含むSokuji（以下総称して「本サービス」といいます）に関連して、情報をどのように収集、使用、開示、保持および保護するかについて説明するものです。',
  'privacy.guarantee.title': '会議コンテンツ',
  'privacy.guarantee.content': '会議コンテンツ（音声、画面コンテキストのためにお客様が選択したウィンドウ、タブまたは画面の画像、文字起こしおよび翻訳）は、お客様のデバイスから、お客様が選択したAIプロバイダーに直接送信されます。当社は、「会議コンテンツの送信」に記載する音声サンプルに関する例外のみを除き、会議コンテンツを当社のサーバー上で受信、処理または保存しません。特に、当社は以下を保存しません：',
  'privacy.guarantee.items': '音声の録音またはその他の音声コンテンツ|画面コンテキストのために送信されるお客様の画面の画像|文字起こし、翻訳またはその他の会話内容',
  'privacy.collect.title': '収集する情報',
  'privacy.collect.content': '「アカウント情報」「ログイン記録」「不正利用防止記録」および「課金、使用量および支払いに関する情報」に記載する情報は、お客様がKizuna AIアカウントを作成または使用する場合にのみ収集されます。利用統計およびエラーレポートは、お客様がログインしているか否かにかかわらず、デスクトップアプリケーション、モバイルアプリケーション、ブラウザ拡張機能およびウェブサイトから収集されます。',
  'privacy.account.title': 'アカウント情報',
  'privacy.account.content': 'お客様がKizuna AIアカウントを作成する場合、当社は以下の情報を収集します：',
  'privacy.account.items': 'メールアドレス：登録、ログイン、アカウントの確認、パスワードの回復およびお試しクレジットの付与に使用します。|パスワード：ソルト付きのscryptハッシュとしてのみ保存します。当社がお客様のパスワードを平文で保存し、または平文のパスワードにアクセスすることは一切ありません。|表示名：お客様が登録時に入力する名前であり、任意のニックネームとすることができます。|アカウント作成日、およびお客様のログイン状態を維持するために使用するセッショントークン。',
  'privacy.signin.title': 'ログイン記録',
  'privacy.signin.content': 'お客様がログインするたびに、当社は、IPアドレス、ユーザーエージェント（ブラウザおよびデバイスの種類）、ならびにIPアドレスから推定されるおおよその位置（国、地域、都市およびおおよその座標）を記録します。当社は、これらの記録を、お客様のログイン状態の維持、お客様のアカウントの保護およびアカウントに関する問題の調査のために使用します。',
  'privacy.abuse.title': '不正利用防止記録',
  'privacy.abuse.content': '同一人物がお試しクレジットを複数回受け取ることを防止するため、当社は、アカウントの活動に関連するIPアドレスを記録します。また、当社は、お試しクレジットの記録として、お試しクレジットを受け取ったメールアドレスの一方向ハッシュ値、および受け取りが拒否された場合には一致したIPアドレスを保持します。',
  'privacy.billing.title': '課金、使用量および支払いに関する情報',
  'privacy.billing.content': '当社は、お客様への請求およびお客様への使用量の表示のため、お客様の残高、チャージおよびセッションごとの使用量（利用時間、プロバイダーおよびリージョンなど）を記録します。支払いはStripeが処理します。お客様のカード番号の全桁はStripeにのみ提供され、当社がこれを受け取ることは一切ありません。支払いの照合および確認のため、当社は、Stripeから一定の支払い情報（支払者の氏名、メールアドレスおよび請求先住所、ならびにカードのブランドおよび下4桁など）を受け取ります。',
  'privacy.collect.analytics.title': '利用統計およびエラーレポート',
  'privacy.collect.analytics.content': '当社は、米国に所在するPostHogを使用して、以下を含む利用統計およびエラーレポートを収集します：',
  'privacy.collect.analytics.items': '使用された機能、選択されたAIプロバイダーおよびセッション時間|エラー、エラーレポートおよびパフォーマンスの測定値|デバイス、オペレーティングシステムおよびブラウザの種類|言語の選択|ブラウザ拡張機能において、お客様が拡張機能を開いたページのウェブサイトのアドレス（ホスト名）',
  'privacy.collect.analytics.identity': 'お客様がログインしている場合、これらの情報は、お客様のアカウントID、メールアドレスおよび表示名と関連付けられます。これらの情報に会議コンテンツは含まれません。本サービスには現在、利用統計を無効にするアプリ内設定はありません。お客様は、「お客様の権利」に記載するとおり、お客様の利用統計データの削除を請求することができます。',
  'privacy.feedback.title': 'フィードバックおよびお問い合わせ',
  'privacy.feedback.content': 'お客様がフィードバックを送信し、または当社に連絡する場合、当社は、お客様のメッセージの内容、お客様のメールアドレス、およびメッセージに付随する技術情報（お客様のブラウザのユーザーエージェント、アプリケーションのバージョンおよびデバイスのモデル、ならびにお客様がログインしている場合はお客様のアカウントIDなど）を受け取ります。',
  'privacy.localOnly.title': 'お客様のデバイスに保存される情報',
  'privacy.localOnly.content': '以下の情報はお客様のデバイスに保存され、当社のサーバーには送信されません：',
  'privacy.localOnly.items': '設定およびお客様ご自身のAPIキー：デスクトップアプリケーションは、これらをお客様のコンピューターにローカルに保存します。モバイルアプリケーションは、お客様の設定をお客様のスマートフォンに保持します。ブラウザ拡張機能は、これらをブラウザの拡張機能用ストレージに保存します。Chrome 同期が有効になっている場合、お客様のブラウザは、Googleのプライバシー条項に従い、お客様のGoogleアカウントを通じてこれらを同期します。|セッション履歴およびエクスポートしたファイル。|オンデバイスモデルのみを使用する場合の、すべての会議コンテンツ。',
  'privacy.storage.transmission.title': '会議コンテンツの送信',
  'privacy.storage.transmission.content': '会議コンテンツは、暗号化された接続を介して、お客様のデバイスからお客様が選択したAIプロバイダーに直接送信されます。お客様がKizuna AIアカウントを使用する場合、当社は、当該プロバイダー用の短時間のみ有効な認証情報を発行し、お客様の使用量を計測しますが、コンテンツ自体が当社のサーバーを経由することはありません。モバイルアプリケーションは、Kizuna AIアカウントを通じてSonioxを使用し、音声を初めて送信する前にお客様の許可を求めます。お客様は、この許可を「設定 > このアプリについて」で取り消すことができます。ローカル推論において「オンライン」と表示されるエンジン（Edge TTSおよびBing 翻訳）は、オンデバイスモデルではありません。これらは、利用可能なオンデバイスモデルがない場合に自動的に使用されるほか、お客様が選択した場合にも使用され、その際、読み上げまたは翻訳の対象となるテキストはMicrosoftに送信されます。例外：お客様がKizuna AIアカウントを使用して複製音声を作成する場合、お客様が録音した音声サンプルは、当該音声を作成するために、当社のサーバーを経由してSonioxに送信されます。当社は、当該音声サンプルを保存しません。当社が保持するのはSonioxから返される音声識別子のみであり、当該音声識別子は、お客様が当該音声またはお客様のアカウントを削除したときに削除されます。',
  'privacy.use.title': '情報の使用方法',
  'privacy.use.items': '本サービスおよびお客様のアカウントの提供、運営および維持|プロバイダーの認証情報の発行、使用量の計測およびお客様への請求|支払いの確認|お試しクレジットの不正利用の防止|アカウントの保護および問題の調査|本サービスの利用状況の把握および本サービスの改善|お客様のフィードバックおよびご依頼への対応|法的義務の遵守',
  'privacy.thirdParty.title': 'サードパーティサービス',
  'privacy.thirdParty.content': '以下の第三者は、本サービスに関連して情報を受け取ります。各第三者は、それぞれ独自のプライバシー条項に従ってこれを処理します。',
  'privacy.thirdParty.cloudflare.title': 'Cloudflare',
  'privacy.thirdParty.cloudflare.content': '当社は、ウェブサイトのホスティング、コンテンツ配信、当社のアカウントおよび課金用データベース（Cloudflare D1）ならびにトランザクションメールのためにCloudflareを使用しています。',
  'privacy.thirdParty.zoho.title': 'Zoho',
  'privacy.thirdParty.zoho.content': '当社のメールアドレス（support@kizuna.ai、privacy@kizuna.ai、contact@kizuna.aiを含みます）は、Zohoによってホスティングされています。お客様が当社に送信したフィードバックおよびメッセージは、Zohoのプライバシー条項に従って、これらのメールボックスに保存されます。',
  'privacy.thirdParty.stripe.title': 'Stripe',
  'privacy.thirdParty.stripe.content': 'Stripeは、チャージの支払いを処理します。Stripeは、Stripeのプライバシーポリシーに従ってお客様の支払いの詳細情報を受け取り、「課金、使用量および支払いに関する情報」に記載する支払い情報を当社に提供します。',
  'privacy.thirdParty.posthog.title': 'PostHog',
  'privacy.thirdParty.posthog.content': '米国に所在するPostHogは、「利用統計およびエラーレポート」に記載する利用統計およびエラーレポートを受け取ります。',
  'privacy.thirdParty.soniox.title': 'Soniox',
  'privacy.thirdParty.soniox.content': 'Sonioxを、ご自身のAPIキーまたはKizuna AIアカウント経由で使用する場合、音声、および音声出力に使用する場合には読み上げの対象となるテキストは、選択したリージョン（米国、欧州連合、日本）のSonioxサーバーに送信され、Sonioxのプライバシーポリシーに従って処理されます。',
  'privacy.thirdParty.alibaba.title': 'Alibaba Cloud（Qwen）',
  'privacy.thirdParty.alibaba.content': 'Qwen LiveTranslateを使用すると、音声と、画面コンテキストがオンのときは選んだウィンドウ・タブ・画面の画像が、Alibaba CloudのQwenサービスに送信されます。ご自身のAPIキーの場合は、そのキーが作成されたリージョン（シンガポール、または中国本土の北京。どちらになるかはキーによります）に送信され、キーを発行したサービス（QwenCloudまたは千问云）の規約に従って処理されます。Kizuna AIアカウント経由の場合は、Sokujiで選んだリージョン（シンガポールまたは北京）に送信され、Alibaba Cloudのプライバシーポリシーに従って処理されます。',
  'privacy.thirdParty.openai.title': 'OpenAI',
  'privacy.thirdParty.openai.content': 'お客様がOpenAIのプロバイダーを使用する場合、音声および関連するテキストはOpenAIに送信され、OpenAIのプライバシーポリシーに従って処理されます。',
  'privacy.thirdParty.google.title': 'Google（Gemini）',
  'privacy.thirdParty.google.content': 'お客様がGeminiを使用する場合、音声および関連するテキストはGoogleに送信され、Googleのプライバシー条項に従って処理されます。',
  'privacy.thirdParty.palabra.title': 'Palabra',
  'privacy.thirdParty.palabra.content': 'お客様がPalabraを使用する場合、音声および関連するテキストはPalabraに送信され、Palabraのプライバシーポリシーに従って処理されます。',
  'privacy.thirdParty.bytedance.title': 'ByteDance（Volcengine）',
  'privacy.thirdParty.bytedance.content': 'お客様がVolcengineの音声翻訳（Doubao）を使用する場合、音声および関連するテキストはByteDanceのVolcengineサービスに送信され、Volcengineのプライバシー条項に従って処理されます。',
  'privacy.thirdParty.microsoft.title': 'Microsoft',
  'privacy.thirdParty.microsoft.content': 'ローカル推論におけるEdge TTSおよびBing 翻訳は、利用可能なオンデバイスモデルがない場合に自動的に使用されるほか、お客様が選択した場合にも使用されます。これらが使用される場合、読み上げまたは翻訳の対象となるテキストはMicrosoftに送信され、Microsoftのプライバシー条項に従って処理されます。',
  'privacy.thirdParty.huggingface.title': 'Hugging Face',
  'privacy.thirdParty.huggingface.content': 'お客様がオンデバイスモデルをダウンロードする場合、ファイルはHugging Faceから取得されます。Hugging Faceは、自らのプライバシーポリシーに従って、お客様のIPアドレスおよびリクエスト情報を受け取ります。',
  'privacy.thirdParty.github.title': 'GitHub',
  'privacy.thirdParty.github.content': 'デスクトップアプリケーションは、GitHubで更新を確認し、GitHubからリリースをダウンロードします。GitHubは、GitHubのプライバシー条項に従って、お客様のIPアドレスおよびリクエスト情報を受け取ります。',
  'privacy.transfer.title': '国際的なデータ移転',
  'privacy.transfer.content': '上記の第三者は、米国、欧州連合、日本、シンガポール、および中国本土（お客様がQwenについて北京リージョンを選択した場合、またはVolcengineを使用する場合）を含む、複数の国において情報を処理します。本サービスを利用することにより、お客様は、お客様の情報がこれらの国に移転され、これらの国において処理される場合があることを理解するものとします。',
  'privacy.storage.title': 'データの保存とセキュリティ',
  'privacy.storage.content': 'アカウント、ログイン、課金および使用量に関する情報は、Cloudflare D1に保存されます。Cloudflare D1は、保存されたデータをAES-256を用いて保存時に暗号化します。情報は、暗号化された（TLS）接続を介して送信されます。',
  'privacy.retention.title': 'データ保持',
  'privacy.retention.content': '当社は、以下の期間、情報を保持します：',
  'privacy.retention.items': 'アカウント情報およびログイン記録：お客様のアカウントが削除されるまで。|不正利用防止用のIP記録：当該IPアドレスが最後に確認されてから90日間。|お試しクレジットの記録（メールアドレスの一方向ハッシュ値、および受け取りが拒否された場合には一致したIPアドレス）：お試しクレジットが再度受け取られることを防止するため、アカウントの削除後も保持します。|課金および使用量の記録（Stripeから受け取った支払い情報を含みます）：お客様のアカウントが存続する間。アカウントの削除後は、適用される現地の法令の定めに従って保持します。|フィードバックおよびお問い合わせ：当社のサポート用メールボックスに保管します。|お客様のデバイスに保存される情報：お客様がアプリケーション内でこれを削除するか、ブラウザのデータを消去するか、アプリケーションのデータフォルダを削除するか、モバイルアプリケーションをアンインストールするまで。エクスポートしたファイルは、お客様が保存した場所に残ります。',
  'privacy.deletion.title': 'アカウント削除',
  'privacy.deletion.content': 'お客様は、いつでも、Kizuna AIダッシュボードのアカウントページから、またはお客様のアカウントのメールアドレスからprivacy@kizuna.aiにメールを送信することにより、お客様のアカウントを削除することができます。お客様のアカウントが削除された場合：',
  'privacy.deletion.items': 'お客様のメールアドレス、表示名、ログイン記録および連携済みのログイン方法は削除されます。|複製音声は、Sonioxが保持する音声を含め、削除されます。|不正利用防止用のIP記録は、「データ保持」に記載する期間に従って削除されます。|お試しクレジットの記録は、「データ保持」に記載するとおり保持されます。|課金および使用量の記録（Stripeから受け取った支払い情報を含みます）は、適用される現地の法令の定めに従って保持されます。|利用統計データは、請求に応じて削除されます。',
  'privacy.rights.title': 'お客様の権利',
  'privacy.rights.content': '適用法令に従い、お客様は、privacy@kizuna.aiまで当社に連絡して、以下を行うことができます：',
  'privacy.rights.items': 'お客様の個人情報へのアクセス、その訂正または削除|お客様の個人情報の写しの取得|お客様の利用統計データの削除の請求|特定の処理に対する異議の申立てまたはその制限の請求|お客様の情報がどのように使用されているかについての問い合わせ',
  'privacy.gdpr.title': '処理の法的根拠（欧州経済領域および英国）',
  'privacy.gdpr.content': 'お客様が欧州経済領域または英国に所在する場合、当社は、お客様との契約の履行（お客様のアカウントおよび課金の提供）のため、当社の正当な利益（本サービスのセキュリティの確保、不正利用の防止および本サービスの改善）に基づき、ならびに法的義務の遵守（課金記録の保持など）のために、個人情報を処理します。お客様は、お客様の所在地のデータ保護機関に苦情を申し立てることもできます。',
  'privacy.children.title': '子供のプライバシー',
  'privacy.children.content': '本サービスは13歳未満の子供を対象としておらず、当社は、13歳未満の子供から、それと知りながら個人情報を収集することはありません。',
  'privacy.changes.title': '本プライバシーポリシーの変更',
  'privacy.changes.content': '当社は、本プライバシーポリシーを随時更新することがあります。当社は、更新後のポリシーを本ページに掲載し、上記の「最終更新日」を改訂します。',
  'privacy.contact.title': 'お問い合わせ',
  'privacy.contact.content': '本プライバシーポリシーについてご質問がある場合：',
  'privacy.contact.email': 'メール：contact@kizuna.ai',
  'privacy.contact.privacy': 'プライバシーリクエスト：privacy@kizuna.ai',
  'privacy.contact.github': 'GitHub：github.com/kizuna-ai-lab/sokuji',

  // Terms of Service
  'tos.title': '利用規約',
  'tos.lastUpdated': '最終更新日：2026年10月21日',

  'tos.intro.title': 'はじめに・同意事項',
  'tos.intro.content': 'Kizuna AI Lab（以下「当社」）が提供するリアルタイムAI翻訳アプリケーション「Sokuji」（以下「本サービス」）をご利用いただきありがとうございます。本利用規約（以下「本規約」）は、ブラウザ拡張機能、デスクトップアプリケーション、および関連サービスへのアクセスおよび利用に適用されます。',
  'tos.intro.agreement': 'Sokujiをダウンロード、インストール、アクセス、または使用することにより、お客様は本規約に拘束されることに同意したものとみなされます。本規約に同意されない場合は、本サービスをご利用いただけません。',

  'tos.definitions.title': '定義',
  'tos.definitions.items': '「本サービス」とは、Sokujiアプリケーション（ブラウザ拡張機能、デスクトップアプリケーション、およびすべての関連機能を含む）を指します。|「ユーザー」「お客様」とは、本サービスにアクセスまたは使用する個人または法人を指します。|「残高」とは、Kizuna AI Labから購入し、Kizuna AI提供の翻訳サービスにアクセスするために使用される、米ドル（USD）建ての前払い残高を指します。|「サードパーティAPIキー」とは、ユーザーがサードパーティのAIサービスプロバイダー（OpenAI、Google、Palabra AIなど）から直接取得したAPI認証情報を指します。|「Kizuna AIサービス」とは、残高から課金されるKizuna AI Labのインフラを通じて提供されるAI翻訳サービスを指します。',

  'tos.service.title': 'サービス内容',
  'tos.service.overview': 'Sokujiは、2つの利用モードでリアルタイムAI翻訳サービスを提供します：',
  'tos.service.freeUsage.title': '無料利用モード（サードパーティAPIキー）',
  'tos.service.freeUsage.items': '対応AIプロバイダー（OpenAI、Google Gemini、Soniox、Qwen LiveTranslate、Palabra AIなど）の自身のAPIキーを接続可能|Kizuna AI Labからの課金なし。選択したAIプロバイダーから直接請求|APIキーのセキュリティと利用制限の管理はユーザーの責任',
  'tos.service.tokenUsage.title': '前払い残高モード（Kizuna AIサービス）',
  'tos.service.tokenUsage.items': 'ユーザーは Kizuna AI Lab から米ドル（USD）建てのプリペイド残高を購入します|Kizuna AI が提供する翻訳サービスの利用時に残高から課金されます|翻訳は AI プロバイダーが計測した実際の使用量に応じて課金され、金額は選択したプロバイダーによって異なります|ウォレットページに時間あたりの目安料金を表示します。実際の使用量に基づくため、通常は目安より低くなります',

  'tos.account.title': 'アカウント登録',
  'tos.account.age': '本サービスを利用するには、13歳以上である必要があります。18歳未満の場合は、保護者の同意を得ていることを表明するものとします。本サービスを利用することにより、お客様はこの年齢要件を満たしていることを表明し保証するものとします。',
  'tos.account.content': '残高を利用するサービスを含む特定の機能にアクセスするには、アカウントを作成する必要があります。お客様は以下に同意するものとします：',
  'tos.account.items': '登録時に正確、最新、完全な情報を提供すること|アカウント認証情報のセキュリティを維持すること|情報を正確かつ最新に保つために速やかに更新すること|アカウント下で発生するすべての活動に対する責任を負うこと',
  'tos.account.security': 'お客様は、アカウントパスワードの機密性を維持し、アカウントへのアクセスを制限する責任を負います。アカウントの不正使用があった場合は、直ちに当社に通知する必要があります。',
  'tos.account.inactivity': '24ヶ月連続で非アクティブ状態（ログインまたはサービス利用がない）のアカウントは、閉鎖の対象となる場合があります。非アクティブアカウントを閉鎖する少なくとも30日前に通知をお送りします。非アクティブアカウントに残っている残高は、アカウント閉鎖時に没収されます。',

  'tos.notifications.title': '通知およびコミュニケーション',
  'tos.notifications.methods': '当社は、以下の方法でお客様に通知を送信する場合があります：(a) Sokuji内のアプリ内通知、(b) アカウントに登録されたメールアドレスへのメール、(c) 当社ウェブサイトへの通知の掲載。お客様は、メールアドレスを最新の状態に保つ責任があります。',
  'tos.notifications.consent': 'アカウントを作成することにより、お客様はこれらの方法により当社から重要なサービス関連のコミュニケーションを受け取ることに同意したものとみなされます。',

  'tos.tokens.title': '残高と支払い',
  'tos.tokens.purchase.title': '残高の購入',
  'tos.tokens.purchase.items': '残高は、対応する支払い方法を使用してアプリ内で購入可能|すべての価格は購入時点で該当する通貨で表示されます|残高はアカウント間で譲渡不可|チャージにより追加された残高は、当該チャージの日から1年間有効',
  'tos.tokens.tax': '表示価格は消費税込みの価格です。日本国外での購入の場合、お客様の管轄地域に応じて現地の税金が適用される場合があります。',
  'tos.tokens.expiration': '残高の有効期限の少なくとも30日前にリマインダー通知をお送りします。有効期限切れの残高は自動的に失効し、回復、返金、延長はできません。有効期限前に残高をご利用いただくことはお客様の責任です。',
  'tos.tokens.promotional': '当社は、メールアドレスの確認時に付与するお試しクレジットなど、無償のプロモーション残高をお客様のアカウントに追加することがあります。プロモーション残高の有効期間は付与時に明示された期間（メール確認のお試しクレジットは七（7）日間）とし、購入した残高より先に消費されます。上記の30日前の通知はプロモーション残高には適用されず、付与時の通知が唯一の通知となります。プロモーション残高は返金・譲渡できず、有効期限を過ぎると失効します。',
  'tos.tokens.consumption.title': '残高の消費',
  'tos.tokens.consumption.content': '翻訳は利用した AI サービスが計測する実際の使用量に応じて課金されるため、金額はプロバイダーとモデルによって異なります。ウォレットページに時間あたりの目安料金を表示しますが、実際の使用量に基づくため、通常は目安より低くなります。残高はセッション中に継続的に減るのではなく、セッション終了後まもなくプロバイダーから使用量が報告された時点で更新されます。',
  'tos.tokens.refund.title': '返金ポリシー',
  'tos.tokens.refund.items': '未使用残高：未使用残高の返金リクエストは、購入から14日以内に提出可能。手数料が適用される場合があります。|消費済み残高：消費された残高は返金不可。|サービス障害：Kizuna AI Labが単独で判断する技術的問題により残高が消費された場合、以下の条件に従い、影響を受けた金額をアカウントにクレジットする場合があります：(a) 問題は発生から30日以内に報告する必要があります；(b) アカウントごとの年間クレジット総額は、その暦年に購入した残高の20%を超えないものとします；(c) Kizuna AI Labは、何が技術的問題に該当するか、およびクレジットが正当かどうかを判断する唯一の権利を留保します。|返金プロセス：購入詳細と返金理由を添えてsupport@kizuna.aiまでご連絡ください。',

  'tos.thirdParty.title': '無料サービス（サードパーティAPIキー）',
  'tos.thirdParty.content': 'サードパーティプロバイダーの自身のAPIキーを使用する場合：',
  'tos.thirdParty.items': 'APIキーの取得と管理についてはお客様の単独の責任となります|各サードパーティプロバイダーの利用規約を遵守する必要があります|サードパーティプロバイダーから発生するすべての料金についてはお客様の責任となります|APIキーはお客様のデバイスにローカルに保存され、当社のサーバーには送信されません',
  'tos.thirdParty.noWarranty': '当社は、サードパーティAIサービスの可用性、品質、またはパフォーマンスについていかなる保証も行いません。サードパーティサービスに関する問題は、該当するプロバイダーに直接お問い合わせください。',

  'tos.use.title': '利用規定',
  'tos.use.permitted.title': '許可された利用',
  'tos.use.permitted.items': '個人的なリアルタイム翻訳|ビジネスコミュニケーションの翻訳|教育目的|アクセシビリティサポート',
  'tos.use.prohibited.title': '禁止事項',
  'tos.use.prohibited.items': '違法または不正な目的での本サービスの使用|本サービスのリバースエンジニアリング、逆コンパイル、または逆アセンブルの試み|本サービスまたはサーバーへの干渉または妨害|有害、攻撃的、または違法なコンテンツの送信に本サービスを使用すること|許可なく本サービスへのアクセスを再販、サブライセンス、または商用化すること|セキュリティ対策やアクセス制限の回避|通常の使用を超えて自動化システムやボットを使用して本サービスにアクセスすること|適用される法律または規制への違反',

  'tos.ip.title': '知的財産',
  'tos.ip.ownership': '本サービス（すべてのソフトウェア、コンテンツ、機能を含む）はKizuna AI Labが所有し、国際著作権法、商標法、その他の知的財産法によって保護されています。',
  'tos.ip.license': '本規約に従い、当社はお客様に対し、個人的または社内業務目的で本サービスを使用するための限定的、非独占的、譲渡不可、取消可能なライセンスを付与します。',
  'tos.ip.userContent': 'お客様が本サービスを通じて提供するコンテンツの所有権はお客様に帰属します。音声および翻訳コンテンツはリアルタイムで処理され、当社は保存しません。',

  'tos.disclaimer.title': '免責事項',
  'tos.disclaimer.asIs': '「現状のまま」でのサービス提供',
  'tos.disclaimer.items': '商品性または特定目的への適合性の黙示保証|翻訳の正確性、信頼性、または完全性|中断のない、またはエラーのない動作|ウイルスやその他の有害なコンポーネントがないこと',
  'tos.disclaimer.accuracy': 'AI翻訳にはエラーが含まれる場合があります。重要なコミュニケーション、法的文書、医療情報、または安全上重要なアプリケーションでは、翻訳のみに依存すべきではありません。',
  'tos.disclaimer.availability': '当社は、本サービスが常に利用可能であることを保証しません。本サービスは、インターネットおよび電子通信の使用に固有の制限、遅延、その他の問題の影響を受ける場合があります。',

  'tos.liability.title': '責任制限',
  'tos.liability.items': 'Kizuna AI Labは、間接的、偶発的、特別、結果的、または懲罰的損害について責任を負わないものとします|当社の総責任は、請求に先立つ12ヶ月間にお客様が残高に対して支払った金額を超えないものとします|当社は、お客様のアカウントへの不正アクセスによって生じた損失について責任を負いません|当社は、サードパーティAIサービスに起因する問題について責任を負いません',

  'tos.indemnification.title': '補償',
  'tos.indemnification.content': 'お客様は、本サービスの利用、本規約への違反、第三者の権利への侵害、サードパーティAPIキーの使用から生じる請求、損害、損失、責任、および費用（弁護士費用を含む）から、Kizuna AI Lab、その役員、取締役、従業員、および代理人を補償し、免責することに同意するものとします。',

  'tos.termination.title': '終了',
  'tos.termination.byUser.title': 'お客様による終了',
  'tos.termination.byUser.items': 'お客様はいつでも本サービスの利用を停止し、アカウントを削除することができます|未使用の残高は没収される場合があります（返金ポリシーに従う）|本サービスへのアクセス権は直ちに停止されます',
  'tos.termination.byUs.title': '当社による終了',
  'tos.termination.byUs.items': '本規約に違反した場合、アクセスを停止または終了する場合があります|お客様の利用がセキュリティリスクをもたらす場合、終了する場合があります|法律により要求される場合、終了する場合があります|本サービスを終了する場合、終了する場合があります',
  'tos.termination.discontinuation': '本サービスを完全に終了する場合、少なくとも30日前に通知します。その場合、未使用の残高をお持ちのユーザーは、終了前12ヶ月以内に購入した残高について、手数料を差し引いた按分返金を請求できます。返金リクエストは終了通知から60日以内に提出する必要があります。',

  'tos.changes.title': '規約の変更',
  'tos.changes.content': '当社はいつでも本規約を変更することができます。重要な変更については、本ページに更新された規約を掲載し、「最終更新日」を更新し、重要な変更についてはアプリ内通知またはメールを送信してお知らせします。変更後も本サービスを継続して利用することは、変更された規約に同意したものとみなされます。',

  'tos.governing.title': '準拠法および紛争解決',
  'tos.governing.informalResolution': '正式な法的手続きを開始する前に、両当事者は誠実な交渉により紛争の解決を試みることに同意します。申立人は、紛争の内容を記載した書面による通知を相手方に送付するものとします。その後、両当事者は60日間の非公式な解決を試みる期間を持ちます。この期間内に紛争が非公式に解決できない場合、いずれかの当事者は以下に記載する正式な法的措置を進めることができます。',
  'tos.governing.law': '本規約は、抵触法の規定にかかわらず、日本法に準拠し、これに従って解釈されるものとします。',
  'tos.governing.jurisdiction': '本規約または本サービスに起因または関連する紛争は、東京地方裁判所を第一審の専属管轄裁判所とします。',
  'tos.governing.language': '本規約の英語版と日本語版の間に齟齬がある場合、日本国内のユーザーについては日本語版が優先するものとします。',

  'tos.general.title': '一般条項',
  'tos.general.entireAgreement': '本規約は、プライバシーポリシーとともに、本サービスに関するお客様とKizuna AI Labとの間の完全な合意を構成します。',
  'tos.general.severability': '本規約のいずれかの条項が執行不能と判断された場合、残りの条項は引き続き完全な効力を維持するものとします。',
  'tos.general.waiver': '当社が本規約の権利または条項を行使しなかった場合でも、それらの権利の放棄とはみなされません。',
  'tos.general.forceMajeure': 'Kizuna AI Labは、自然災害、戦争、テロリズム、暴動、パンデミック、政府の措置、停電、インターネットまたは通信の障害、第三者サービスプロバイダーの障害を含むがこれに限定されない、合理的な制御を超えた事情による本規約上の義務の不履行または遅延について責任を負わないものとします。',

  'tos.contact.title': 'お問い合わせ',
  'tos.contact.content': '本規約に関するご質問がございましたら、以下までお問い合わせください：',
  'tos.contact.legal': '法務：legal@kizuna.ai',
  'tos.contact.support': 'サポート：support@kizuna.ai',
  'tos.contact.github': 'GitHub：github.com/kizuna-ai-lab/sokuji',

  // Dashboard Navigation
  'dashboard.nav.dashboard': 'ダッシュボード',
  'dashboard.nav.profile': 'プロフィール',
  'dashboard.nav.security': 'セキュリティ',
  'dashboard.nav.feedback': 'フィードバック',
  'dashboard.nav.signOut': 'ログアウト',
  'dashboard.user.fallback': 'ユーザー',
  'dashboard.sidebar.collapse': 'サイドバーを折りたたむ',
  'dashboard.sidebar.expand': 'サイドバーを展開',

  // Dashboard Home
  'dashboard.home.welcomeBack': 'おかえりなさい、{name}さん',
  'dashboard.home.subtitle': 'アカウント設定と環境設定を管理',
  'dashboard.home.accountOverview': 'アカウント概要',
  'dashboard.home.accountStatus': 'アカウントステータス',
  'dashboard.home.accountDetails': 'アカウント詳細',
  'dashboard.home.quickActions': 'クイックアクション',
  'dashboard.home.name': '名前',
  'dashboard.home.email': 'メールアドレス',
  'dashboard.home.emailVerified': 'メール認証',
  'dashboard.home.accountType': 'アカウントタイプ',
  'dashboard.home.userId': 'ユーザーID',
  'dashboard.home.created': '作成日',
  'dashboard.home.lastUpdated': '最終更新',
  'dashboard.home.notSet': '未設定',
  'dashboard.home.verified': '認証済み',
  'dashboard.home.notVerified': '未認証',
  'dashboard.home.anonymous': '匿名',
  'dashboard.home.registered': '登録済み',
  'dashboard.home.editProfile': 'プロフィールを編集',
  'dashboard.home.securitySettings': 'セキュリティ設定',
  'dashboard.home.na': 'N/A',

  // Dashboard Profile
  'dashboard.profile.title': 'プロフィール設定',
  'dashboard.profile.subtitle': '個人情報を管理',
  'dashboard.profile.personalInfo': '個人情報',
  'dashboard.profile.personalInfoDesc': '名前と基本情報を更新',
  'dashboard.profile.nameLabel': '名前',
  'dashboard.profile.namePlaceholder': 'お名前',
  'dashboard.profile.saveChanges': '変更を保存',
  'dashboard.profile.profileUpdated': 'プロフィールが更新されました',
  'dashboard.profile.emailAddress': 'メールアドレス',
  'dashboard.profile.emailAddressDesc': 'メールアドレスと認証状態を管理',
  'dashboard.profile.currentEmail': '現在のメールアドレス',
  'dashboard.profile.verified': '認証済み',
  'dashboard.profile.notVerified': '未認証',
  'dashboard.profile.resendVerification': '認証メールを再送信',
  'dashboard.profile.verificationSent': '認証メールを送信しました！受信トレイをご確認ください。',
  'dashboard.profile.changeEmailTitle': 'メールアドレスの変更',
  'dashboard.profile.newEmailLabel': '新しいメールアドレス',
  'dashboard.profile.newEmailPlaceholder': 'new@email.com',
  'dashboard.profile.newEmailHint': '新しいアドレスに認証メールが送信されます',
  'dashboard.profile.changeEmail': 'メールアドレスを変更',
  'dashboard.profile.emailChangeSent': '新しいメールアドレスに認証メールを送信しました。ご確認ください。',

  // Dashboard Security
  'dashboard.security.title': 'セキュリティ設定',
  'dashboard.security.subtitle': 'パスワードとアカウントセキュリティを管理',
  'dashboard.security.changePassword': 'パスワードを変更',
  'dashboard.security.changePasswordDesc': 'アカウントを安全に保つためにパスワードを更新',
  'dashboard.security.currentPassword': '現在のパスワード',
  'dashboard.security.currentPasswordPlaceholder': '現在のパスワードを入力',
  'dashboard.security.newPassword': '新しいパスワード',
  'dashboard.security.newPasswordPlaceholder': '8文字以上',
  'dashboard.security.confirmPassword': '新しいパスワードを確認',
  'dashboard.security.confirmPasswordPlaceholder': '新しいパスワードを確認',
  'dashboard.security.changePasswordBtn': 'パスワードを変更',
  'dashboard.security.activeSessions': 'アクティブセッション',
  'dashboard.security.activeSessionsDesc': 'アクティブなログインセッションを管理（{count}件アクティブ）',
  'dashboard.security.current': '現在',
  'dashboard.security.lastActive': '最終アクティブ：{time}',
  'dashboard.security.loadingSessions': 'セッションを読み込み中...',
  'dashboard.security.signOutOther': '他のすべてのセッションをログアウト',
  'dashboard.security.deleteAccount': 'アカウントを削除',
  'dashboard.security.deleteAccountDesc': 'アカウントと関連するすべてのデータを完全に削除',
  'dashboard.security.deleteWarning': 'この操作は取り消せません。すべてのデータが完全に削除されます。',
  'dashboard.security.deleteBtn': 'アカウントを削除',
  'dashboard.security.deleteConfirmText': '削除を確認するには、下にDELETEと入力してください：',
  'dashboard.security.deleteConfirmPlaceholder': 'DELETEと入力して確認',
  'dashboard.security.cancel': 'キャンセル',
  'dashboard.security.anonymousNote': '匿名アカウントはパスワードを変更できません。まず正式なアカウントに変換してください。',
  'dashboard.security.passwordMinLength': '新しいパスワードは8文字以上である必要があります',
  'dashboard.security.passwordMismatch': 'パスワードが一致しません',
  'dashboard.security.passwordIncorrect': '現在のパスワードが正しくありません',
  'dashboard.security.passwordSuccess': 'パスワードが変更されました。他のセッションはログアウトされました。',
  'dashboard.security.typeDelete': 'DELETEと入力して確認してください',

  // Dashboard Feedback
  'dashboard.feedback.title': 'フィードバックを送信',
  'dashboard.feedback.subtitle': 'バグ報告、機能提案、ご意見をお聞かせください。すべてのメッセージを読んでいます！',
  'dashboard.feedback.yourFeedback': 'フィードバック',
  'dashboard.feedback.sendingAs': '送信者：{email}',
  'dashboard.feedback.remainingCount': '本日の残り送信可能数：{remaining}/{limit}件',
  'dashboard.feedback.limitReached': '本日の上限に達しました。明日また送信できます。',
  'dashboard.feedback.feedbackType': 'フィードバックの種類',
  'dashboard.feedback.bugReport': 'バグ報告',
  'dashboard.feedback.bugReportDesc': '問題や不具合を報告',
  'dashboard.feedback.suggestion': '機能提案',
  'dashboard.feedback.suggestionDesc': '新機能や改善を提案',
  'dashboard.feedback.other': 'その他',
  'dashboard.feedback.otherDesc': '一般的なフィードバックや質問',
  'dashboard.feedback.message': 'メッセージ',
  'dashboard.feedback.messagePlaceholder': 'フィードバックの詳細を記述してください...',
  'dashboard.feedback.messageHint': '{count}/5000文字（最低10文字）',
  'dashboard.feedback.sendFeedback': 'フィードバックを送信',
  'dashboard.feedback.verificationRequired': 'メール認証が必要です',
  'dashboard.feedback.verificationRequiredDesc': 'フィードバックを送信する前にメールアドレスを認証してください。返信のため認証済みメールが必要です。',
  'dashboard.feedback.goToProfile': 'プロフィール設定へ',
  'dashboard.feedback.thankYou': 'ありがとうございます！フィードバックが送信されました。',

  // Dashboard Wallet
  'dashboard.wallet.title': 'ウォレット',
  'dashboard.wallet.subtitle': '残高とチャージを管理',
  'dashboard.wallet.balance': '残高',
  'dashboard.wallet.hoursLeft': '利用時間の目安（{scenario}）',
  'dashboard.wallet.hoursLeftAverage': '利用時間の目安（直近30日の平均 {rate}/時間）',
  'dashboard.wallet.hoursValue': '約 {hours} 時間',
  'dashboard.wallet.recentRecords': '最近の記録',
  'dashboard.wallet.allRecords': 'すべての記録',
  'dashboard.wallet.fullPricing': '料金表をすべて表示',
  'dashboard.wallet.plan': '現在のプラン',
  'dashboard.wallet.last30Days': '過去30日間',
  'dashboard.wallet.expiringSoon': '${amount} は {date} に期限切れになります',
  'dashboard.wallet.expiringSoonPartial': '${amount} は {date} に期限切れ、1か月以内に合計 ${total}',
  'dashboard.wallet.accountFrozen': 'アカウントが凍結されています。サポートにお問い合わせください。',
  'dashboard.wallet.topUp': 'チャージ',
  'dashboard.wallet.customAmount': 'カスタム金額',
  'dashboard.wallet.amountRange': '最小：{min} - 最大：{max}',
  'dashboard.wallet.youWillReceive': '獲得予定',
  'dashboard.wallet.paymentMethod': 'お支払い方法',
  'dashboard.wallet.methodCard': 'カード',
  'dashboard.wallet.methodAlipay': 'Alipay（支付宝）',
  'dashboard.wallet.continueWithAmount': 'お支払いへ進む · {amount}',
  'dashboard.wallet.poweredByStripe': '決済は Stripe により安全に処理されます。',
  'dashboard.wallet.alipayCharge': '日本円で請求：{amount}',
  'dashboard.wallet.alipayRate': 'レート 1 USD = {rate} 円（欧州中央銀行、{date}）',
  'dashboard.wallet.alipayRateChanged': '為替レートが更新されました。新しい金額をご確認のうえ、もう一度お試しください。',
  'dashboard.wallet.otherPaymentMethods': 'その他のお支払い方法',
  'dashboard.wallet.processing': '処理中...',
  'dashboard.wallet.pricing.provider': 'Sonioxの課金、リアルタイムストリーミングのみ',

  // THE CALCULATOR. Its scenario presets, and their titles and descriptions,
  // follow kizuna-ai-lab/sokuji's own first-run wizard
  // (`setup.scenarios.*` there) so the dashboard and the app name the same
  // thing the same way, as are /scenarios' `scenario.<id>.title`/`.body`. The
  // two repos cannot share catalogs: `app-scenarios.fixture.ts` pins the
  // wizard's strings and `scenario-copy.test.ts` holds both pages to them, so
  // when the app rewords a scenario, update the fixture and these together.
  'dashboard.wallet.pricing.calcTitle': '料金計算ツール',
  'dashboard.wallet.pricing.calcScenario': '何に使いますか？',
  'dashboard.wallet.pricing.calcEstimate': '概算料金',
  'dashboard.wallet.pricing.calcFactors': 'この概算の内訳',
  'dashboard.wallet.pricing.scenario.understand-others.title': '相手の話を理解する',
  'dashboard.wallet.pricing.scenario.understand-others.desc': 'オンライン会議・授業・講演・動画・配信——聞こえる内容の翻訳をリアルタイムで読みます。',
  'dashboard.wallet.pricing.scenario.be-heard.title': '会議で自分の話を伝える',
  'dashboard.wallet.pricing.scenario.be-heard.desc': '相手には仮想マイク経由で翻訳音声が届きます。',
  'dashboard.wallet.pricing.scenario.subtitle-myself.title': '自分の話に字幕を付ける',
  'dashboard.wallet.pricing.scenario.subtitle-myself.desc': '講演・配信・プレゼン——視聴者は翻訳字幕を読みます。音声は生成しません。',
  'dashboard.wallet.pricing.scenario.two-way-voice.title': 'オンラインで双方向に会話',
  'dashboard.wallet.pricing.scenario.two-way-voice.desc': '相手はあなたの翻訳音声を聞き、あなたは相手の字幕を読めて、翻訳音声を聞くこともできます。',
  'dashboard.wallet.pricing.scenario.two-way-text.title': 'オンラインで双方向に会話（字幕のみ）',
  'dashboard.wallet.pricing.scenario.two-way-text.desc': '二か国語字幕や議事録——双方ともテキストで、合成音声は使いません。',
  'dashboard.wallet.pricing.scenario.face-to-face-voice.title': '対面で会話',
  'dashboard.wallet.pricing.scenario.face-to-face-voice.desc': '2 人が 1 台のパソコンでそれぞれの言語で話し、各自が片耳のイヤホンで自分の言語の翻訳だけを聞きます。',
  'dashboard.wallet.pricing.scenario.face-to-face-text.title': '対面で会話（字幕のみ）',
  'dashboard.wallet.pricing.scenario.face-to-face-text.desc': '2 人で同じ画面を見るか、相手がスマートフォンで LAN 字幕ページを開きます。',
  'dashboard.wallet.pricing.engine': 'エンジン',
  'dashboard.wallet.pricing.region': 'リージョン',
  'dashboard.wallet.pricing.regionSg': 'シンガポール',
  'dashboard.wallet.pricing.regionCn': '北京',
  'dashboard.wallet.pricing.scenario.custom.title': 'カスタム',
  'dashboard.wallet.pricing.scenario.custom.desc': '下の各項目を使い方に合わせて設定します。どれかを変えるとここに切り替わります。',
  'dashboard.wallet.pricing.sideThem': '相手の発言',
  'dashboard.wallet.pricing.sideMe': '自分の発言',
  'dashboard.wallet.pricing.output.off': '翻訳しない',
  'dashboard.wallet.pricing.output.text': '字幕で表示',
  'dashboard.wallet.pricing.output.voiceThem': '自分に読み上げる',
  'dashboard.wallet.pricing.output.voiceMe': '相手に読み上げる',
  'dashboard.wallet.pricing.shareThem': '相手が話す時間',
  'dashboard.wallet.pricing.shareMe': '自分が話す時間',
  'dashboard.wallet.pricing.shareValue': '{count}% · 1時間あたり約 {minutes} 分',
  'dashboard.wallet.pricing.screenContext': '画面コンテキスト',
  'dashboard.wallet.pricing.screenContextHint': 'Qwen エンジンは、あなたが選んだ1つのウィンドウ、タブ、または画面を見ます。発話1時間あたり、方向ごとに課金されます。',
  'dashboard.wallet.pricing.balanceLasts': '残高 {balance} で約 {hours} 時間',
  'dashboard.wallet.pricing.balanceLastsUnderOne': '残高 {balance} では1時間に足りません',
  'dashboard.wallet.pricing.trait.soniox': '60言語を相互に翻訳し、字幕と音声の両方に対応。プリセットの声のほか、録音から自分の声も作れます。1台のパソコンでの対面会話にも対応。',
  'dashboard.wallet.pricing.trait.qwen': '話者本人の声で訳文を読み上げられます。一文ごとにリアルタイムで声を複製するので、事前の録音は不要です。読み上げは29言語、字幕は60言語。',
  'dashboard.wallet.pricing.sharedActive': '1本の共有ストリームとして概算：対面では2方向が1つの接続を共有します。',
  'dashboard.wallet.pricing.sharedHint': '対面会話、または双方で1本のストリームを共有する場合：接続が1つ減り、1時間あたり約 {amount} 安くなります。',
  'dashboard.wallet.pricing.needOneSide': '少なくとも一方の発言を翻訳すると料金が表示されます。',
  'dashboard.wallet.pricing.partConnection': '接続 × {count}',
  'dashboard.wallet.pricing.partText': 'テキスト',
  'dashboard.wallet.pricing.partVoice': '音声',
  'dashboard.wallet.pricing.partScreen': '画面コンテキスト',
  'dashboard.wallet.pricing.partTotal': '合計',
  'dashboard.wallet.pricing.colItem': '項目',
  'dashboard.wallet.pricing.colUnitPrice': '単価',
  'dashboard.wallet.pricing.colHourly': '1時間あたり',
  'dashboard.wallet.pricing.usePerConnectedHour': '接続1時間あたり {count} トークン',
  'dashboard.wallet.pricing.usePerSpeechHour': '発話1時間あたり {count} トークン',
  'dashboard.wallet.pricing.usePerSpokenHour': '読み上げ1時間あたり {count} トークン',
  'dashboard.wallet.pricing.usePerScreenHour': '画面コンテキストあり、発話1時間あたり {count} トークン',
  'dashboard.wallet.pricing.providerQwen': '{name}の課金、リアルタイムストリーミングのみ',

  'dashboard.wallet.pricing.perHourApprox': '≈ {amount}/時間',
  'dashboard.wallet.pricing.assumptions': '翻訳する方向ごとに接続が1つあり、誰かが話しているかどうかにかかわらず、接続している間はずっと課金されます。テキストは翻訳される人が話している時間に、音声は読み上げた分だけに課金されます。話す時間は一人ずつ設定するので、一方をオンにしても、その分の料金が加わるだけです。',
  'dashboard.wallet.pricing.settlement': 'これらの数値は見積もりであり、確定金額ではありません。実際に請求される金額は、エンジンがそのセッションについて報告するトークン数に基づいて決まります。',
  'dashboard.wallet.pricing.rateInputAudio': '入力音声トークン',
  'dashboard.wallet.pricing.rateOutputText': '出力テキストトークン',
  'dashboard.wallet.pricing.rateTtsInputText': '入力テキストトークン',
  'dashboard.wallet.pricing.rateTtsOutputAudio': '出力音声トークン',
  'dashboard.wallet.pricing.rateInputImage': '入力画像トークン（画面コンテキスト）',
  'dashboard.wallet.pricing.perMillion': '{amount} / 100万トークン',
  'dashboard.wallet.pricing.cnyPerMillion': 'CN¥{amount} / 100万トークン',
  'dashboard.wallet.pricing.fxNote': '{date} の欧州中央銀行レートで換算：1 米ドル = {rate} 人民元。レートは毎日更新されます。',
  'dashboard.wallet.pricing.sttReference': '1時間の音声は約30,000入力音声トークン • 1時間の発話は約15,000出力テキストトークン • 出力1文字は約0.3トークン',
  'dashboard.wallet.pricing.ttsReference': '1文字 ≈ 0.3入力テキストトークン • 15,000入力テキストトークン ≈ 1時間の生成音声 • 1時間の生成音声 ≈ 30,000出力音声トークン',
  'dashboard.wallet.pricing.referenceNote': 'プロバイダーからの引用です。翻訳では文字起こしと翻訳の両方が生成されるため、1時間の発話が生み出す出力テキストトークンは上記の約2倍になります — 表で使われているのはこの数値です。',
  'dashboard.wallet.pricing.readOn': 'プロバイダーの価格は{date}時点のものです。',
  'dashboard.wallet.pricing.error': '料金の読み込みに失敗しました',
  'dashboard.wallet.pricing.retry': '再試行',
  'dashboard.wallet.pricing.boundariesHeading': '課金される対象',
  'dashboard.wallet.pricing.boundaryConnection': '接続されたストリームは、誰かが話しているかどうかに関わらず課金されます。各ストリームは接続しているだけで1時間あたり約{count}入力音声トークンを消費し、発話があるとそれに加えて出力テキストが発生します。',
  'dashboard.wallet.pricing.boundaryReservation': 'セッションを開始すると、保守的なレートでそれをまかなうのに十分な残高が予約され、これがセッションを実行できる時間を決定します。残高は実際に使用した分だけ変動し、予約のうち使われなかった分が差し引かれることは決してありません。',
  'dashboard.wallet.pricing.boundaryCurrency': 'すべての金額は米ドル建てです。',
  'dashboard.wallet.pricing.faqHeading': 'よくある質問',
  'dashboard.wallet.pricing.faqTranslationQ': '翻訳は別料金ですか？',
  'dashboard.wallet.pricing.faqTranslationA': 'いいえ。文字起こしと翻訳は同じストリームで行われ、翻訳は上記の料金にすでに含まれています。',
  'dashboard.wallet.pricing.faqFeaturesQ': '話者分離、言語検出、フォーマット処理は追加料金がかかりますか？',
  'dashboard.wallet.pricing.faqFeaturesA': 'いいえ。話者分離、言語識別、スマートフォーマットは追加料金なしで含まれています。',
  'dashboard.billing.title': '請求',
  'dashboard.billing.subtitle': '残高・クレジット・お支払い',
  'dashboard.usage.title': '使用量',
  'dashboard.usage.subtitle': 'セッションの消費内訳',
  'dashboard.usage.sessionTime': 'のセッション時間',
  'dashboard.usage.sessions': 'セッション',
  'dashboard.usage.chartStart': '{{days}}日前',
  'dashboard.usage.chartEnd': '今日',
  'dashboard.usage.chartLabel': '期間中の日別利用額',
  'dashboard.usage.noSpend': '利用なし',
  'dashboard.wallet.ledger.billingTitle': '請求履歴',
  'dashboard.wallet.ledger.viewReceipt': '領収書を見る',
  'dashboard.wallet.lots.title': 'クレジット',
  'dashboard.wallet.lots.totalRemaining': '利用可能',
  'dashboard.wallet.lots.colCreated': '追加日',
  'dashboard.wallet.lots.colAmount': '金額',
  'dashboard.wallet.lots.colUsed': '使用済み',
  'dashboard.wallet.lots.colRemaining': '残り',
  'dashboard.wallet.lots.colExpires': '有効期限',
  'dashboard.wallet.lots.colStatus': '状態',
  'dashboard.wallet.lots.status.active': '有効',
  'dashboard.wallet.lots.status.expiring': 'まもなく期限切れ',
  'dashboard.wallet.lots.status.spent': '使い切り',
  'dashboard.wallet.lots.status.expired': '期限切れ',
  'dashboard.wallet.lots.empty': 'クレジットはまだありません。',
  'dashboard.wallet.lots.error': 'クレジットを読み込めませんでした。',
  'dashboard.wallet.lots.retry': '再試行',
  'dashboard.wallet.paymentHistory': '支払い履歴',
  'dashboard.wallet.noHistory': '支払い履歴はありません',
  'dashboard.wallet.loading': 'ウォレットを読み込み中...',
  'dashboard.wallet.paymentSuccess': '支払いが完了しました！残高が更新されました。',
  'dashboard.wallet.paymentUnavailable': 'オンライン決済は現在利用できません。後でもう一度お試しください。',
  'dashboard.wallet.errorFetchingBalance': 'ウォレット残高の取得に失敗しました',
  'dashboard.wallet.minAmountError': '最小金額は {min} です',
  'dashboard.wallet.maxAmountError': '最大金額は {max} です',
  'dashboard.wallet.paymentError': '支払いに失敗しました。もう一度お試しください。',

  // Dashboard Wallet — billing ledger
  'dashboard.wallet.ledger.title': '取引履歴',
  'dashboard.wallet.ledger.kind.sttSpeaker': '自分の音声認識',
  'dashboard.wallet.ledger.kind.sttParticipant': '相手の音声認識',
  'dashboard.wallet.ledger.kind.translateSpeaker': '自分の音声翻訳',
  'dashboard.wallet.ledger.kind.translateParticipant': '相手の音声翻訳',
  'dashboard.wallet.ledger.kind.sttMixed': '結合音声認識',
  'dashboard.wallet.ledger.kind.stt': '音声認識',
  'dashboard.wallet.ledger.kind.tts': '音声合成',
  'dashboard.wallet.ledger.kind.ttsPreview': '音声試聴',
  'dashboard.wallet.ledger.kind.topup': 'チャージ',
  'dashboard.wallet.ledger.kind.grant': '付与クレジット',
  'dashboard.wallet.ledger.kind.adjustment': 'アカウント調整',
  'dashboard.wallet.ledger.kind.refund': '返金',
  'dashboard.wallet.ledger.kind.expired': '残高の期限切れ',
  'dashboard.wallet.ledger.kind.usage': '利用',
  'dashboard.wallet.ledger.kind.voicePreview': '音声試聴',
  'dashboard.wallet.ledger.group.session': '翻訳セッション',
  'dashboard.wallet.ledger.mode.me': '自分',
  'dashboard.wallet.ledger.mode.other': '相手',
  'dashboard.wallet.ledger.mode.both': '両方',
  'dashboard.wallet.ledger.textOnly': 'テキストのみ',
  'dashboard.wallet.ledger.poweredBy': '{name} 提供',
  'dashboard.wallet.engine.qwenSingapore': 'Qwen (シンガポール)',
  'dashboard.wallet.engine.qwenBeijing': 'Qwen (北京)',
  'dashboard.wallet.ledger.segments': 'セグメント',
  'dashboard.wallet.ledger.prevPage': '前へ',
  'dashboard.wallet.ledger.nextPage': '次へ',
  'dashboard.wallet.ledger.prevPageAria': '前のページ',
  'dashboard.wallet.ledger.nextPageAria': '次のページ',
  'dashboard.wallet.ledger.page': '{page} ページ',
  'dashboard.wallet.ledger.empty': '取引履歴はまだありません',
  'dashboard.wallet.ledger.error': '取引履歴の読み込みに失敗しました',
  'dashboard.wallet.ledger.retry': '再試行',
  'dashboard.wallet.ledger.expandRow': '内訳を表示',
  'dashboard.wallet.ledger.collapseRow': '内訳を隠す',

  // Dashboard Navigation - Wallet
  'dashboard.nav.wallet': 'ウォレット',
  'dashboard.nav.billing': '請求',
  'dashboard.nav.usage': '使用量',

  // Commerce Disclosure (特定商取引法に基づく表記)
  'commerce.title': '特定商取引法に基づく表記',
  'commerce.lastUpdated': '最終更新日：2026年10月6日',

  // Operator Information
  'commerce.operator.title': '事業者情報',
  'commerce.operator.name.label': '事業者の名称',
  'commerce.operator.name.value': 'Kizuna AI Lab',
  'commerce.operator.representative.label': '運営責任者',
  'commerce.operator.representative.value': 'SHINONOME TAKU',
  'commerce.operator.address.label': '所在地',
  'commerce.operator.address.value': '請求があった場合、遅滞なく開示いたします',
  'commerce.operator.phone.label': '電話番号',
  'commerce.operator.phone.value': '請求があった場合、遅滞なく開示いたします（お問い合わせはメールにてお願いいたします）',
  'commerce.operator.email.label': 'メールアドレス',
  'commerce.operator.email.value': 'support@kizuna.ai',
  'commerce.operator.url.label': 'URL',
  'commerce.operator.url.value': 'https://sokuji.kizuna.ai',

  // Price
  'commerce.price.title': '販売価格',
  'commerce.price.description': '価格は以下の通りです。表示価格は税込みです。',
  'commerce.price.items': 'プリペイド残高は米ドル（USD）建てです。お支払いいただいた金額が残高に加算されます|翻訳は選択した AI プロバイダーが計測した実際の使用量に応じて課金されます。時間あたりの目安料金はウォレットページに表示されます|最低購入額：5 米ドル|最高購入額：100 米ドル',
  'commerce.price.tax': '日本国内のお客様：表示価格には消費税が含まれています。日本国外のお客様：お客様の居住地に応じて現地の税金が適用される場合があります。',

  // Additional Fees
  'commerce.additionalFees.title': '商品代金以外の必要料金',
  'commerce.additionalFees.description': '本サービスのご利用にあたり、残高のご購入代金以外の追加費用は発生しません。',

  // Payment
  'commerce.payment.title': 'お支払い方法',
  'commerce.payment.items': 'クレジットカード|デビットカード|Apple Pay|Google Pay|Link|Alipay（支付宝）',
  'commerce.payment.note': '決済処理はStripe, Inc.を通じて行われます。利用可能な決済手段はStripeの対応状況により異なる場合があります。Alipayでのお支払いは日本円で請求され、米ドル建ての金額をお支払い前に表示する欧州中央銀行の参照レートで換算します。',

  // Payment Period
  'commerce.paymentPeriod.title': '支払い期限',
  'commerce.paymentPeriod.content': 'クレジットカードおよびAlipayでの決済は購入手続き完了時にただちに処理されます。',

  // Delivery
  'commerce.delivery.title': '役務の提供時期',
  'commerce.delivery.items': 'お支払い完了後、プリペイド残高は直ちにアカウントへ反映されます|AI 翻訳サービスはリアルタイムで提供されます。残高は、セッション終了後まもなくプロバイダーが使用量を報告した時点で、実際の使用量に応じて課金されます|残高の有効期限は購入日から 1 年間です',

  // Refund / Exchange Policy
  'commerce.refund.title': '返品・交換について',
  'commerce.refund.customerRequest.title': '＜お客様都合による返品・交換＞',
  'commerce.refund.customerRequest.content': 'デジタルサービスの性質上、購入後の前払い残高の返品・交換は原則としてお受けしておりません。ただし、未使用の残高については、購入から14日以内であれば返金をリクエストできます。手数料が適用される場合があります。返金をご希望の場合は、購入詳細と返金理由を添えて support@kizuna.ai までご連絡ください。',
  'commerce.refund.defect.title': '＜不良品・サービス欠陥の場合の返品・交換＞',
  'commerce.refund.defect.content': '技術的問題によりサービスが正常に提供されなかった場合、または残高が正しく課金されなかった場合は、support@kizuna.ai までご連絡ください。調査の上、影響を受けた金額をアカウントにクレジットいたします。',

  // Environment
  'commerce.environment.title': '動作環境',
  'commerce.environment.items': 'ブラウザ拡張機能：Chrome 116以上、Edge 116以上（Chromiumベース）|デスクトップアプリ：Windows 10以上、macOS 13以上、Linux（Ubuntu 20.04以上推奨）|インターネット接続：安定したブロードバンド接続が必要です|マイク：音声入力に対応したマイクデバイスが必要です',

  // Contact
  'commerce.contact.title': 'お問い合わせ',
  'commerce.contact.description': 'ご質問やお問い合わせは、以下の連絡先までご連絡ください。',
  'commerce.contact.email': 'メール：support@kizuna.ai',
  'commerce.contact.github': 'GitHub：github.com/kizuna-ai-lab/sokuji',

  // Navigation
  'nav.commerce': '特定商取引法に基づく表記',

  // Participant Audio Feature
  'nav.participantAudio': '相手の音声',

  // Overview

  // How It Works

  // Platform Support

  // How to Enable

  // Platform Differences

  // Tips

  // FAQ

  // Device Selection Guide

  // Uninstall Feedback
  'uninstall.loading': 'アンケートを読み込み中...',
  'uninstall.retry': '再試行',
  'uninstall.fallbackTitle': 'ご利用ありがとうございました',
  'uninstall.fallbackSubtitle': '該当するすべての理由を選択してください。皆様のフィードバックが改善に役立ちます。',
  'uninstall.otherPlaceholder': '詳しくお聞かせください...',
  'uninstall.submitButton': 'フィードバックを送信',
  'uninstall.tryDesktop': '{link} をお試しください — より多くの機能、あらゆるアプリに対応',
  'uninstall.thankyouTitle': 'フィードバックありがとうございます！',
  'uninstall.thankyouSubtitle': 'お時間をいただきありがとうございます。皆様のフィードバックは、今後の Sokuji の改善に役立てさせていただきます。',
  'uninstall.reinstallPrompt': 'お気が変わりましたか？いつでも Sokuji を再インストールできます。',
  'uninstall.reinstallButton': 'Chrome ウェブストアから再インストール',
  'uninstall.needMoreFeatures': 'もっと多くの機能が必要ですか？',
  'uninstall.needMoreFeaturesDesc': '対応していないウェブサイトやカスタム API プロバイダーをご希望の場合は、デスクトップ版をお試しください！',
  'uninstall.tryDesktopClient': 'Sokuji デスクトップ版を試す',
  'uninstall.getInTouch': 'お問い合わせ',
  'uninstall.reportBug': 'バグを報告：',
  'uninstall.shareIdea': 'アイデアを共有：',
  'uninstall.copyright': '© {year} Sokuji. 無断転載を禁じます。',

  // Subtitle Mode Feature
  'nav.subtitleMode': '字幕モード',
  'nav.basicFeatures': '基本機能',
  'nav.feature.translationModes': '翻訳モード',
  'nav.feature.virtualMicrophone': '仮想マイク',
  'nav.feature.textOnly': '読み上げまたはテキストのみ',
  'nav.feature.display': '表示設定',
  'nav.feature.pronunciationReadings': '読みの表示',
  'nav.feature.export': 'エクスポートと自動保存',
  'nav.feature.replay': '翻訳の再生',
  'nav.feature.noiseSuppression': 'ノイズ抑制',
  'nav.feature.passthrough': '原音パススルー',
  'nav.feature.switchDevices': 'デバイスの切り替え',
  'nav.feature.diagnosticLogs': '診断ログ',
  'nav.feature.interfaceLanguage': 'インターフェース言語',
  'nav.feature.captionSharing': '字幕の共有',

  // Overview

  // How to enter and exit

  // Floating bar layout

  // Customization

  // Pin and Lock

  // Compact vs. expanded rows

  // Tips and limitations

  // FAQ
  // Local models (/docs/local-models)
  'localModels.title': 'ローカルモデルとライセンス',
  'localModels.intro': 'Sokuji の無料モードでダウンロードできるすべてのモデルについて、用途、サイズ、提供元、そして重みのライセンスをまとめています。',
  'localModels.runtimeTitle': 'モデルの実行環境',
  'localModels.runtimeBody': 'モデルはブラウザ内で動作します。CPU では WebAssembly（WASM）、GPU では WebGPU を使います。WebGPU モデルには、WebGPU に対応したブラウザとグラフィックスカードが必要です。それ以外の動作速度はお使いのデバイスによって異なります。サイズはダウンロード容量で、Sokuji のモデル一覧に表示される数値と同じです。モデルの読み込みには少なくともこの容量のメモリが必要です。',
  'localModels.variantsNote': '複数のバリアントがあるモデルでは、Sokuji がお使いのデバイスで使えるものを選びます。名前に f16 を含むバリアントには、16 ビットシェーダーに対応した GPU が必要です。',
  'localModels.licenseTitle': 'ライセンス',
  'localModels.licenseBody': 'Sokuji 自体は無料のオープンソースで、AGPL-3.0 で公開されています。モデルは Sokuji の一部ではなく、それぞれの提供元が独自のライセンスで公開しているもので、下の表に記載しています。非商用利用のみを認めるものや、ライセンスをまったく示していないものもあります。モデルを使う際は、提供元の条件に従ってください。',
  'localModels.tier.open.label': 'オープンライセンス',
  'localModels.tier.open.desc': '寛容なライセンス、またはクレジット表記のみを求めるライセンスです（MIT、Apache-2.0、BSD、CC0、CC BY、CC BY-SA）。',
  'localModels.tier.conditional.label': '条件付き',
  'localModels.tier.conditional.desc': '利用できますが、クレジット表記以外の条件があります（地域の制限、利用ポリシー、コピーレフトなど）。内容は備考に記載しています。',
  'localModels.tier.non-commercial.label': '非商用',
  'localModels.tier.non-commercial.desc': '提供元が非商用利用のみを認めているか、商用利用を独自の条件でのみ認めています。',
  'localModels.tier.unstated.label': 'ライセンス未記載',
  'localModels.tier.unstated.desc': '提供元がライセンスを付与していません。',
  'localModels.tier.cloud.label': 'オンラインサービス',
  'localModels.tier.cloud.desc': 'ダウンロードは不要です。テキストをオンラインサービスに送信するため、インターネット接続が必要です。',
  'localModels.flag.non-commercial-base': '非商用のベース音声',
  'localModels.flag.removed-upstream': '提供元が公開を停止',
  'localModels.flag.game-character': 'ゲームキャラクターの声',
  'localModels.flagNcBase': '非商用のベース音声：Piper の lessac または ryan の音声をもとにファインチューニングされた音声です。これらの学習データは非商用利用のみに許諾されています。この音声自体のライセンスには、その条件が引き継がれるかどうかの記載がありません。',
  'localModels.type.asr': '音声認識',
  'localModels.type.asr-stream': 'ストリーミング音声認識',
  'localModels.type.translation': '翻訳',
  'localModels.type.tts': '音声合成',
  'localModels.type.punctuation': '句読点',
  'localModels.runtime.wasm': 'CPU（WASM）',
  'localModels.runtime.webgpu': 'WebGPU',
  'localModels.runtime.cloud': 'オンライン',
  'localModels.col.model': 'モデル',
  'localModels.col.languages': '言語',
  'localModels.col.runtime': '実行環境',
  'localModels.col.size': 'サイズ',
  'localModels.col.source': '提供元',
  'localModels.col.license': 'ライセンス',
  'localModels.col.notes': '備考',
  'localModels.multilingual': '多言語',
  'localModels.package': 'パッケージ',
  'localModels.filterLabel': 'ライセンス',
  'localModels.search': '名前・言語・ライセンスで絞り込み',
  'localModels.showing': '{count} 件のモデルを表示中',
  'localModels.noMatch': '条件に一致するモデルはありません。',
  'localModels.bundled': 'すべてのオフライン音声認識パッケージに含まれるもの：',
  'localModels.generatedFrom': 'Sokuji {version} から生成しました。',

  // Account deletion page
  'deleteAccount.title': 'Sokuji アカウントの削除',
  'deleteAccount.intro': 'Sokuji は Kizuna AI が開発しています。Android アプリや iOS アプリを含むすべてのプラットフォームで、Sokuji には Kizuna AI アカウントでサインインします。このページでは、アカウントの削除方法とデータの取り扱いについて説明します。削除したアカウントは元に戻せません。',
  'deleteAccount.app.title': 'Sokuji モバイルアプリで削除する',
  'deleteAccount.app.items': 'メイン画面のメニューを開く|「アカウント」をタップする|「アカウントを削除」をタップして確認する',
  'deleteAccount.web.title': 'ウェブサイトで削除する',
  'deleteAccount.web.items': 'sokuji.kizuna.ai にサインインする|ダッシュボードを開き、「セキュリティ」に移動する|「アカウントを削除」を選択し、DELETE と入力して確認する',
  'deleteAccount.email.title': 'サインインできない場合',
  'deleteAccount.email.content': 'アカウントのメールアドレスから privacy@kizuna.ai にメールを送り、削除を依頼してください。',
  'deleteAccount.deleted.title': '削除されるデータ',
  'deleteAccount.deleted.items': 'アカウント（メールアドレス、表示名、パスワード、サインイン記録を含む）|残高（復元できません）|作成したカスタムボイス',
  'deleteAccount.partial.title': 'アカウントを削除せずに一部のデータを削除する',
  'deleteAccount.partial.items': '端末に保存された文字起こし：アプリで「履歴」を開いて削除します|利用状況の分析データ：privacy@kizuna.ai にメールを送り、削除を依頼してください',
};

export default ja;
